//import CryptoJS from "crypto-js";
//import axios from "axios";

import * as geolib from "geolib";
import { Plugins } from "@capacitor/core";
import { v4 as uuidv4 } from "uuid";

import gp from "@/mixins/gp";
import stripe from "@/mixins/stripe";
import rest from "@/mixins/rest";
import utils from "@/mixins/utils";

export default {
  mixins: [gp, stripe, rest, utils],

  data() {
    return {
      inputRules: {
        required: value => !!value || "Required",
        vcode: value => !!value || "Verification code is required",
        email: value => {
          return this.$isValidEmail(value) || "Invalid e-mail";
        },
        emailOpt: value => {
          return !value || this.$isValidEmail(value) || "Invalid e-mail";
        },
        phone: value => {
          return this.$isValidPhoneNumber(value) || "Invalid phone number";
        },
        phoneOpt: value => {
          return !value || this.$isValidPhoneNumber(value) || "Invalid phone number";
        },
        postal: value => {
          return this.$isValidPostal(value) || "Invalid postal code";
        },
        postalOpt: value => {
          return !value || this.$isValidPostal(value) || "Invalid postal code";
        },
      },
    };
  },

  computed: {
    deliveryAddressString() {
      return this.addressToString(this.$store.state.order.address, " ");
    },

    storeAddressString() {
      return this.addressToString(this.$store.getters.storeAddress, " ");
    },

    showLangSwitcher() {
      return this.$store.getters.languages.length > 1;
    },

    keyCompanyCode() {
      let companyCode =
        this.$appMode == 1 ? this.$store.state.appToken.CompanyCode : this.$store.getters.storeCompanyCode;
      return companyCode;
    },
  },

  methods: {
    addressToString(address, delimiter) {
      if (delimiter === undefined) {
        delimiter = ", ";
      }
      let addrStr = "";
      if (address != null && typeof address == "object") {
        if (address.unit !== undefined && address.unit != null && address.unit != "")
          addrStr += (addrStr == "" ? "" : delimiter) + "Unit " + address.unit;
        if (address.street !== undefined && address.street != null && address.street != "")
          addrStr += (addrStr == "" ? "" : delimiter) + address.street;
        if (address.city !== undefined && address.city != null && address.city != "")
          addrStr += (addrStr == "" ? "" : delimiter) + address.city;
        if (address.province !== undefined && address.province != null && address.province != "")
          addrStr += (addrStr == "" ? "" : delimiter) + address.province;
        if (address.postal !== undefined && address.postal != null && address.postal != "")
          addrStr += (addrStr == "" ? "" : delimiter) + address.postal;
      }

      return addrStr;
    },

    isFullScreenDialog() {
      return window.innerWidth < 600;
    },

    getLaunchTime() {
      let time = null;
      let key = "LTM_" + this.$store.getters.storageKey;
      if (localStorage.getItem(key)) {
        time = this.toDate(localStorage.getItem(key));
      }

      return time;
    },

    setLaunchTime() {
      let key = "LTM_" + this.$store.getters.storageKey;
      localStorage.setItem(key, Date());
    },

    getCovidFormSubmitTime() {
      let time = null;
      let key = "CTF_" + this.$store.getters.storeCompanyCode;
      if (localStorage.getItem(key)) {
        time = this.toDate(localStorage.getItem(key));
      }

      return time;
    },

    setCovidFormSubmitTime() {
      let key = "CTF_" + this.$store.getters.storeCompanyCode;
      localStorage.setItem(key, Date());
    },

    getLastLogin() {
      let that = this;
      return new Promise(function(resolve) {
        let key = "LOC_" + that.$store.getters.storageKey;
        console.log("getLastLoginKey", key);
        that.$idb.setting
          .get(key)
          .then(record => resolve(record.value))
          .catch(() => resolve(null));
      });
    },

    setLastLogin(lastLogin) {
      let that = this;
      return new Promise(function(resolve) {
        let key = "LOC_" + that.$store.getters.storageKey;
        that.$idb.setting
          .put({ name: key, value: lastLogin })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            console.log("setLastLogin catched", error);
            resolve(false);
          });
      });
    },

    getLastLogin_v1() {
      let lastLogin = null;
      //let key = "LOC_" + this.$store.getters.storeCompanyCode;
      let key = "LOC_" + this.$store.getters.storageKey;
      if (localStorage.getItem(key)) {
        lastLogin = JSON.parse(localStorage.getItem(key));
      }

      return lastLogin;
    },

    setLastLogin_v1(lastLogin) {
      //let key = "LOC_" + this.$store.getters.storeCompanyCode;
      let key = "LOC_" + this.$store.getters.storageKey;
      localStorage.setItem(key, JSON.stringify(lastLogin));
    },

    cartOnRightShown() {
      return (
        this.$vuetify.breakpoint.mdAndUp &&
        (this.$router.currentRoute.name == "MenuFull" ||
          this.$router.currentRoute.name == "MenuCategory" ||
          (this.$router.currentRoute.name == "MenuItem" &&
            this.$router.currentRoute.params.getNewBundleItem ==
              null)) /* ||
              this.$router.currentRoute.name == "Order" ||
              this.$router.currentRoute.name == "OrderBundle"*/
      );
    },

    setTheme(theme) {
      if (theme == null) return;

      //this.$vuetify.theme.dark = false;
      if ("primary" in theme) {
        this.$vuetify.theme.themes.light.primary = theme.primary;
        this.$vuetify.theme.themes.dark.primary = theme.primary;
      }
      if ("secondary" in theme) {
        this.$vuetify.theme.themes.light.secondary = theme.secondary;
        this.$vuetify.theme.themes.dark.secondary = theme.secondary;
      }
      if ("accent" in theme) {
        this.$vuetify.theme.themes.light.accent = theme.accent;
        this.$vuetify.theme.themes.dark.accent = theme.accent;
      }
      if ("info" in theme) {
        this.$vuetify.theme.themes.light.info = theme.info;
        this.$vuetify.theme.themes.dark.info = theme.info;
      }
      if ("success" in theme) {
        this.$vuetify.theme.themes.light.success = theme.success;
        this.$vuetify.theme.themes.dark.success = theme.success;
      }
      if ("warning" in theme) {
        this.$vuetify.theme.themes.light.warning = theme.warning;
        this.$vuetify.theme.themes.dark.warning = theme.warning;
      }
      if ("error" in theme) {
        this.$vuetify.theme.themes.light.error = theme.error;
        this.$vuetify.theme.themes.dark.error = theme.error;
      }
      if ("primaryText" in theme) {
        this.$vuetify.theme.themes.light.primaryText = theme.primaryText;
        this.$vuetify.theme.themes.dark.primaryText = theme.primaryText;
      }
      if ("secondaryText" in theme) {
        this.$vuetify.theme.themes.light.secondaryText = theme.secondaryText;
        this.$vuetify.theme.themes.dark.secondaryText = theme.secondaryText;
      }
      if ("accentText" in theme) {
        this.$vuetify.theme.themes.light.accentText = theme.accentText;
        this.$vuetify.theme.themes.dark.accentText = theme.accentText;
      }
      if ("infoText" in theme) {
        this.$vuetify.theme.themes.light.infoText = theme.infoText;
        this.$vuetify.theme.themes.dark.infoText = theme.infoText;
      }
      if ("warningText" in theme) {
        this.$vuetify.theme.themes.light.warningText = theme.warningText;
        this.$vuetify.theme.themes.dark.warningText = theme.warningText;
      }

      if (theme.primary != null) {
        let ele = document.querySelector('meta[name="theme-color"]');
        if (ele) {
          /*
          let styles = getComputedStyle(document.documentElement);        
          let primaryColor = styles.getPropertyValue("--v-primary-base");
          */
          console.log("Changing theme color to " + theme.primary);
          ele.setAttribute("content", theme.primary);
        }
      }
    },

    setNextLanguage() {
      if (this.$store.getters.languages.length <= 1) return;

      let langIndex = this.$store.getters.languages.indexOf(this.$store.state.languageSelected);
      let nextLang = this.$store.state.languageSelected;
      if (this.$store.getters.languages.length == langIndex + 1) nextLang = this.$store.getters.languages[0];
      else nextLang = this.$store.getters.languages[langIndex + 1];

      this.setLanguage(nextLang);
    },

    // getDistance({ latitude: 51.5103, longitude: 7.49347 }, { latitude: "51° 31' N", longitude: "7° 28' E" });
    getDistance(coords1, coords2) {
      let distance = geolib.getDistance(coords1, coords2);
      return distance;
    },

    getCoords(address) {
      var addressObj = {
        address_line_1: address,
        //address_line_2: "",
        //city: "",
        //state: "CA", // province also valid
        //zip_code: "94043", // postal_code also valid
        //country: "",
      };
      console.log(addressObj);

      let that = this;
      return new Promise(function(resolve, reject) {
        that.$geocoder.send(addressObj, response => {
          console.log(response);
          let result = {
            status: response.status,
            coords: null,
            metadata: null,
          };
          if (response.status == "OK" && response.results.length > 0) {
            //resolve(response.results[0].geometry.location);
            result.coords = response.results[0].geometry.location;
            result.metadata = response.results;
            resolve(result);
          } else {
            reject(result);
            //reject(response.status);
          }
        });
      });
    },

    // enableHighAccuracy will cause geolocation slow in iOS
    async getMyCoords() {
      const options = {
        //enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      };

      let myCoords;
      if (this.$store.getters.isNativeApp) {
        const { Geolocation } = Plugins;
        let myPosition = await Geolocation.getCurrentPosition(options);
        myCoords = {
          latitude: myPosition.coords.latitude,
          longitude: myPosition.coords.longitude,
        };
      } else {
        let myPosition = await this.$geolocation.getCurrentPosition(options);
        myCoords = myPosition.coords;
      }

      console.log("MyCoords", myCoords);
      return myCoords;
    },

    async getStoreDistance(myAddress) {
      console.log("getting store distance");
      console.log("myAddress", myAddress);

      let result = "ok";
      let message = "";
      let content = {
        myCoords: { lat: 0, lng: 0 },
        storeCoords: { lat: 0, lng: 0 },
        distanceBetween: 0,
      };

      try {
        let myCoords = null;
        let storeCoords = null;
        if (myAddress !== undefined && myAddress != null && myAddress != "") {
          let getCoordsResult = await this.getCoords(myAddress);
          if (getCoordsResult.status == "OK") {
            myCoords = {
              latitude: getCoordsResult.coords.lat,
              longitude: getCoordsResult.coords.lng,
            };
          }
        } else {
          myCoords = await this.getMyCoords();
        }

        console.log("myCoords", myCoords);

        let store = this.$store.state.store;
        if (myCoords != null) {
          let storeCoordsLat = null;
          let storeCoordsLng = null;
          if (store.coords !== undefined) {
            storeCoordsLat = store.coords.lat;
            storeCoordsLng = store.coords.lng;
          }
          if (storeCoordsLat == null || storeCoordsLng == null) {
            if (this.storeAddressString != "") {
              let getCoordsResult = await this.getCoords(this.storeAddressString);
              if (getCoordsResult.status == "OK") {
                storeCoords = {
                  latitude: getCoordsResult.coords.lat,
                  longitude: getCoordsResult.coords.lng,
                };
              }
            }
          } else {
            storeCoords = {
              latitude: storeCoordsLat,
              longitude: storeCoordsLng,
            };
          }

          //console.log(store.coords);
          console.log("storeCoords", storeCoords);

          if (myCoords != null && storeCoords != null) {
            let distanceBetween = this.getDistance(myCoords, storeCoords);
            let distanceMatrix = await this.rest_getDistanceMatrix(myCoords, storeCoords);

            content = {
              myCoords: { lat: myCoords.latitude, lng: myCoords.longitude },
              storeCoords: { lat: storeCoordsLat, lng: storeCoordsLng },
              distanceBetween: distanceBetween,
              distanceMatrix: distanceMatrix,
            };
            result = "ok";
          } else {
            result = "failed";
            message = "Location information is unavailable";
          }
        } else {
          result = "failed";
          message = "Location information is unavailable";
        }
      } catch (error) {
        console.log(error);

        result = "failed";
        message = this.getPositionErrorMessage(error);
      }

      let response = { result: result, message: message, content: content };
      console.log(response);
      return response;
    },

    async checkDistance(allowDistance, myAddress) {
      console.log("checkDistance/allowDistance=" + allowDistance);
      console.log("checkDistance/myAddress=" + myAddress);

      let res = {
        result: "ok",
        message: "",
        content: {
          myCoords: { lat: 0, lng: 0 },
          storeCoords: { lat: 0, lng: 0 },
          distanceBetween: 0,
        },
      };

      let n_res = await this.getStoreDistance(myAddress);
      if (n_res.result == "ok") {
        res.content = n_res.content;
      }
      if (allowDistance > 0) {
        if (n_res.result == "ok") {
          let distanceMeter = 0;
          if (
            res.content.distanceMatrix != null &&
            res.content.distanceMatrix.rows != null &&
            res.content.distanceMatrix.rows.length > 0
          ) {
            let row = res.content.distanceMatrix.rows[0];
            if (row.elements != null && row.elements.length > 0) {
              let ele = row.elements[0];
              distanceMeter = ele.distance.value;
            }
          } else {
            distanceMeter = res.content.distanceBetween;
          }

          if (distanceMeter > allowDistance) {
            res.result = "failed";
            res.message = "You are far away from the store";
          }
        } else {
          res.result = "failed";
          res.message = n_res.message;
        }
      }

      console.log("checkDistance/result", res);
      return res;
    },

    async getDeliveryQuote(address) {
      let addrChanged = false;
      let addrError = false;
      let quote = {};

      if (!addrError && !addrChanged && this.$store.getters.doorDashEnabled) {
        let res = await this.rest_doorDashEstimate({
          address: address,
          deliveryTime: new Date(),
        });
        if (res.result == "ok") {
          let dropOffAddress = res.data.dropoff_address;
          let n_dropOffAddress = { ...address };
          n_dropOffAddress.unit = dropOffAddress.unit;
          n_dropOffAddress.street = dropOffAddress.street;
          n_dropOffAddress.city = dropOffAddress.city;
          n_dropOffAddress.province = dropOffAddress.state;
          n_dropOffAddress.postal = dropOffAddress.zip_code;

          let pickupTime = this.toDate(res.data.pickup_time);
          let deliveryTime = this.toDate(res.data.delivery_time);
          let deliveryDriveMin = Math.ceil((deliveryTime - pickupTime) / 60 / 1000);
          let deliveryValue = this.roundNumber(res.data.fee / 100, 2);
          deliveryValue = this.$store.getters.deliveryAdjustedCharge(deliveryValue);

          quote.result = res.result;
          quote.doorDashDriveID = res.DriveId;
          quote.address = n_dropOffAddress;
          quote.deliveryValue = deliveryValue;
          quote.deliveryDriveMin = deliveryDriveMin;

          addrChanged = true;
        } else {
          let errorMessage = res.result;
          if ("field_errors" in res.data && Array.isArray(res.data.field_errors) && res.data.field_errors.length > 0) {
            errorMessage = res.data.field_errors[0].field + " - " + res.data.field_errors[0].error;
          }
          quote.error = errorMessage;
          addrError = true;
        }
      }

      if (!addrError && !addrChanged && this.$store.getters.faceDriveEnabled) {
        let res = await this.rest_faceDriveGetQuote({ address: address });
        if (res.result == "ok") {
          let pickupTime = this.toDate(res.data.expectant_pickup_at);
          let deliveryTime = this.toDate(res.data.expectant_delivery_at);
          let deliveryDriveMin = Math.ceil((deliveryTime - pickupTime) / 60 / 1000);
          let deliveryValue = this.roundNumber(this.toFloat(res.data.grand_total) - this.toFloat(res.data.tax), 2);
          deliveryValue = this.$store.getters.deliveryAdjustedCharge(deliveryValue);

          quote.result = res.result;
          quote.address = address;
          quote.deliveryValue = deliveryValue;
          quote.deliveryDriveMin = deliveryDriveMin;
          quote.deliveryWithhold = this.toFloat(res.data.grand_total);

          addrChanged = true;
        } else {
          quote.error = res.error;
          quote.errorCode = res.upstream_error;
          addrError = true;
        }
      }

      let deliveryAgentEnabled = this.$store.getters.doorDashEnabled || this.$store.getters.faceDriveEnabled;
      let deliveryAgentChargeIgnored = !this.$store.getters.deliveryAgentChargeUsed && deliveryAgentEnabled;

      if (!addrError && (!addrChanged || deliveryAgentChargeIgnored)) {
        let deliveryAddressString = this.addressToString(address);
        let res = await this.checkDistance(this.$store.getters.deliveryMaxDistance, deliveryAddressString);
        if (res.result == "ok" || deliveryAgentChargeIgnored) {
          let distanceMeter = 0;
          let deliveryValue = 0;
          let deliveryDriveMin = 0;
          if (
            res.content.distanceMatrix != null &&
            res.content.distanceMatrix.rows != null &&
            res.content.distanceMatrix.rows.length > 0
          ) {
            let row = res.content.distanceMatrix.rows[0];
            if (row.elements != null && row.elements.length > 0) {
              let ele = row.elements[0];
              distanceMeter = ele.distance.value;
              deliveryValue = this.$store.getters.deliveryCharge(distanceMeter);
              deliveryDriveMin = Math.ceil(ele.duration.value / 60);
            }
          } else {
            distanceMeter = res.content.distanceBetween;
            deliveryValue = this.$store.getters.deliveryCharge(distanceMeter);
            deliveryDriveMin = Math.ceil((distanceMeter / 1000) * 1.2);
          }

          if (!deliveryAgentEnabled) {
            quote.result = res.result;
            quote.address = address;
            quote.deliveryDriveMin = deliveryDriveMin;
          }
          quote.deliveryValue = deliveryValue;

          addrChanged = true;
        } else {
          quote.error = res.message;
          addrError = true;
        }
      }

      if (quote.result == "ok") {
        if (quote.deliveryWithhold == null) quote.deliveryWithhold = 0;
      }

      console.log("Delivery Quote", quote);
      return quote;
    },

    getPositionErrorMessage(positionError) {
      //"An unknown error occurred";
      let errorMessage = this.$t("position_error.unknown");
      if (positionError !== undefined) {
        //"User denied the request for Geolocation";
        if (positionError.code == 1) errorMessage = this.$t("position_error.1");
        //"Location information is unavailable";
        else if (positionError.code == 2) errorMessage = this.$t("position_error.2");
        //"The request to get user location timed out";
        else if (positionError.code == 3) errorMessage = this.$t("position_error.3");
      }

      return errorMessage;
    },

    getStoreLocaleDate(store, date) {
      let localeDate = date;
      try {
        let storeUtcOffsetMin = store.info.timeZoneUtcOffsetMin;
        let localUtcOffsetMin = date.getTimezoneOffset();
        if (storeUtcOffsetMin !== undefined && storeUtcOffsetMin != -localUtcOffsetMin) {
          var today_utc = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
          let today_tz = new Date(today_utc.setMilliseconds(today_utc.getMilliseconds() + 60000 * storeUtcOffsetMin));
          localeDate = today_tz;
        }
      } catch (error) {
        console.log(error);
      }

      return localeDate;
    },

    getStoreTimeStatus(store) {
      let bhStatus = {
        now: new Date(),
        timeZoneAbbrev: "",
        opening: false,
        businessTimeLocaleString: "",
        businessTimeParams: {},
        preorderLocaleString: "",
      };

      let faceDriveEnabled =
        store.orderType != null && store.orderType.delivery != null && store.orderType.delivery.faceDriveEnabled;
      let currentTime = new Date();
      let storeCurrentTime = this.getStoreLocaleDate(store, currentTime);
      if (currentTime != storeCurrentTime) {
        currentTime = storeCurrentTime;

        if (store.info.timeZoneAbbrev !== undefined) {
          bhStatus.timeZoneAbbrev = store.info.timeZoneAbbrev;
        }
      }
      bhStatus.now = currentTime;

      let currentTimeString =
        currentTime
          .getHours()
          .toString()
          .padStart(2, "0") +
        ":" +
        currentTime
          .getMinutes()
          .toString()
          .padStart(2, "0");
      let dow = currentTime.getDay();
      let bHours = store.info.businessHours;
      let bDay = bHours[dow];
      let opening = false;

      if (!bDay.off && bDay.timeFrom == bDay.timeTo) {
        bhStatus.businessTimeLocaleString = "business_time.open_24hr";
        bhStatus.timeZoneAbbrev = "";
        opening = true;
      } else {
        opening = this.timeInRanges(bDay.times, currentTimeString);

        let openTimes =
          this.stringToStandardTimeString(bDay.timeFrom) + "-" + this.stringToStandardTimeString(bDay.timeTo);
        if (bDay.off && bDay.times.length == 1) {
          let time = bDay.times[0];
          openTimes = this.stringToStandardTimeString(time.from) + "-" + this.stringToStandardTimeString(time.to);
        } else if ("times" in bDay && bDay.times.length == 2) {
          let time = bDay.times[0];
          if (time.from == "00:00" && time.to > currentTimeString) {
            let lastDow = dow - 1;
            if (lastDow < 0) lastDow = 6;
            let yesterday = bHours[lastDow];
            openTimes =
              this.stringToStandardTimeString(yesterday.timeFrom) +
              "-" +
              this.stringToStandardTimeString(yesterday.timeTo);
          }
        }

        bhStatus.businessTimeParams = { openTimes: openTimes };
        if (opening) bhStatus.businessTimeLocaleString = "business_time.open_time";
        else {
          if (bDay.off && bDay.times.length == 0) bhStatus.businessTimeLocaleString = "business_time.closed_today";
          else bhStatus.businessTimeLocaleString = "business_time.close_time";
        }
      }
      bhStatus.opening = opening;

      let preorderLocaleString = "";
      if (!opening && store.info.takeoutHours != null && store.info.deliveryHours != null) {
        let takeoutDisabled = false;
        let deliveryDisabled = false;
        if (store != null) {
          if (
            store.orderType !== undefined &&
            store.orderType.takeout !== undefined &&
            store.orderType.takeout.hide !== undefined
          )
            takeoutDisabled = store.orderType.takeout.hide;
          if (
            store.orderType !== undefined &&
            store.orderType.delivery !== undefined &&
            store.orderType.delivery.hide !== undefined
          )
            deliveryDisabled = store.orderType.delivery.hide;
        }

        let acceptOrderForTakeout = false;
        let acceptOrderForDelivery = false;
        if (!takeoutDisabled && store.info.takeoutHours.length == 7) {
          let tHours = store.info.takeoutHours;
          let tDay = tHours[dow];
          acceptOrderForTakeout = this.timeInRanges(tDay.times, currentTimeString);
        }
        if (!deliveryDisabled && store.info.deliveryHours.length == 7) {
          let dHours = store.info.deliveryHours;
          let dDay = dHours[dow];
          acceptOrderForDelivery = this.timeInRanges(dDay.times, currentTimeString);
          if (acceptOrderForDelivery && faceDriveEnabled && store.info.transportHours.length == 7) {
            let dtHours = store.info.transportHours;
            let dtDay = dtHours[dow];
            acceptOrderForDelivery = this.timeInRanges(dtDay.times, currentTimeString);
          }
        }

        if (acceptOrderForTakeout && acceptOrderForDelivery) preorderLocaleString = "accept_preorder";
        else if (acceptOrderForTakeout) preorderLocaleString = "accept_preorder.takeout";
        else if (acceptOrderForDelivery) preorderLocaleString = "accept_preorder.delivery";
      }

      bhStatus.preorderLocaleString = preorderLocaleString;

      return bhStatus;
    },

    timeInRanges(times, timeString) {
      let inRange = false;
      if (times !== undefined) {
        for (let tt of times) {
          if (tt.from !== undefined && tt.to !== undefined) {
            if (tt.from == tt.to || (tt.from <= timeString && (tt.to == "00:00" || tt.to >= timeString))) {
              inRange = true;
              break;
            }
          }
        }
      }
      return inRange;
    },

    getLaunchMin() {
      let currentTime = new Date();
      let launchMin = (currentTime.getTime() - this.$store.state.launchTime.getTime()) / 1000 / 60;

      return launchMin;
    },

    getVerifiedPhoneNumbers() {
      if (this.$idb == null) return null;
      let that = this;
      return new Promise(function(resolve) {
        let key = "VERIFIED_PHONE_NUMBERS";
        that.$idb.setting
          .get(key)
          .then(record => resolve(record.value))
          .catch(() => resolve(null));
      });
    },

    setVerifiedPhoneNumbers(phoneNumbers) {
      if (this.$idb == null) return false;
      let that = this;
      return new Promise(function(resolve) {
        let key = "VERIFIED_PHONE_NUMBERS";
        that.$idb.setting
          .put({ name: key, value: phoneNumbers })
          .then(() => {
            resolve(true);
          })
          .catch(error => {
            console.log("setVerifiedPhoneNumbers catched", error);
            resolve(false);
          });
      });
    },

    addVerifiedPhoneNumber(phoneNumber) {
      let that = this;
      return new Promise(function(resolve) {
        that
          .getVerifiedPhoneNumbers()
          .then(phoneNumbers => {
            if (!Array.isArray(phoneNumbers)) phoneNumbers = [];
            let index = phoneNumbers.indexOf(phoneNumber);
            if (index < 0) {
              phoneNumbers.unshift(phoneNumber);
              that
                .setVerifiedPhoneNumbers(phoneNumbers)
                .then(result => {
                  resolve(result);
                })
                .catch(error => {
                  console.log("addVerifiedPhoneNumber catched", error);
                  resolve(false);
                });
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            console.log("addVerifiedPhoneNumber catched", error);
            return resolve(false);
          });
      });
    },

    isVerifiedPhoneNumber(phoneNumber) {
      let that = this;
      return new Promise(function(resolve) {
        if (that.$store.state.testMode && phoneNumber == "+1" + that.$store.state.testPhoneNo) {
          return resolve(true);
        } else {
          that
            .getVerifiedPhoneNumbers()
            .then(phones => {
              let index = phones == null ? -1 : phones.indexOf(phoneNumber);
              return resolve(index > -1);
            })
            .catch(error => {
              console.log("isVerifiedPhoneNumber catched", error);
              return resolve(false);
            });
        }
      });
    },

    getVerifiedPhoneNumbers_v1() {
      let phones = null;
      let key = "VERIFIED_PHONE_NUMBERS";
      if (localStorage.getItem(key)) {
        phones = JSON.parse(localStorage.getItem(key));
      }
      return phones;
    },

    setVerifiedPhoneNumbers_v1(phoneNumbers) {
      let key = "VERIFIED_PHONE_NUMBERS";
      localStorage.setItem(key, JSON.stringify(phoneNumbers));
    },

    addVerifiedPhoneNumber_v1(phoneNumber) {
      let key = "VERIFIED_PHONE_NUMBERS";
      let phoneNumbers = [];
      if (localStorage.getItem(key)) {
        let val = localStorage.getItem(key);
        try {
          phoneNumbers = JSON.parse(val);
          if (!Array.isArray(phoneNumbers)) {
            phoneNumbers = [];
          }
        } catch (err) {
          phoneNumbers = [];
        }
      }
      phoneNumbers.unshift(phoneNumber);
      localStorage.setItem(key, JSON.stringify(phoneNumbers));
    },

    isVerifiedPhoneNumber_v1(phoneNumber) {
      let key = "VERIFIED_PHONE_NUMBERS";
      if (localStorage.getItem(key)) {
        let phones = localStorage.getItem(key);
        let index = phones.indexOf(phoneNumber);
        return index > -1;
      } else {
        return false;
      }
    },

    async confirmSwitchOrderType(orderType) {
      if (orderType == this.$store.state.OT_DINEIN && !this.$store.getters.storeDineinMenuMode) {
        if (this.$store.getters.storeDineinAskTableName) {
          let tableName = await this.$root.tableNameDialog();
          if (tableName != null) {
            let res = await this.rest_getTable({ tableName: tableName });
            if (res.result == "ok" && res.tables.length > 0) {
              let table = res.tables[0];
              this.$store.state.order.tableID = table.ID;
              this.$store.state.order.tableName = table.descr;
            } else {
              this.$root.messageDialog(
                this.$t("error_alert_title"),
                "",
                this.$t("error_table_not_found", { table_name: tableName })
              );
              return false;
            }
          } else {
            return false;
          }
        }
      } else {
        this.$store.state.order.tableID = 0;
        this.$store.state.order.tableName = "";
      }

      let switchOrderType = true;
      let om = this.$store.getters.storeOrderType(orderType);

      let o_priceLevel = this.$store.state.order.priceLevel;
      let n_priceLevel = 0;
      if (om.priceLevel !== undefined && Number.isInteger(om.priceLevel)) n_priceLevel = om.priceLevel;

      if (this.$store.state.order.orderItems.length > 0) {
        if (o_priceLevel != n_priceLevel) {
          switchOrderType = await this.$root.confirmDialog(
            this.$t("confirm_title_switch_ordertype") + this.$t(orderType) + "?",
            "",
            this.$t("confirm_leave_clear_cart"),
            { yesText: this.$t("confirm_button_switch") }
          );
        } else {
          if (orderType == this.$store.state.OT_DINEIN) {
            let promoOi = this.$store.state.order.orderItems.find(x => x.promo != null);
            if (promoOi != null) {
              switchOrderType = await this.$root.confirmDialog(
                this.$t("confirm_title_switch_ordertype") + this.$t(orderType) + "?",
                "",
                this.$t("confirm_leave_remove_promo_cart"),
                { yesText: this.$t("confirm_button_switch") }
              );
            }
          }
        }
      }
      return switchOrderType;
    },

    moveAddressToFirst(address) {
      if (this.$store.state.addressList === undefined) return;

      this.$store.state.addressList = this.$store.state.addressList.filter(a => a !== address);
      this.$store.state.addressList.unshift(address);
    },

    countQtyTotal() {
      this.$store.state.order.qtyTotal = 0;
      this.$store.state.order.redeemedPointsTotal = 0;
      for (let oi of this.$store.state.order.orderItems) {
        this.$store.state.order.qtyTotal += oi.qty;
        if (oi.redeemItem) {
          this.$store.state.order.redeemedPointsTotal += oi.redeemPoints * oi.qty;
        }
      }
    },

    async isSessionValid() {
      let valid = true;
      let launchMin = this.$store.getters.launchMin();
      //console.log('launchMin', launchMin);
      //let launchMin = this.getLaunchMin();

      if (launchMin > 120) {
        valid = false;
      } else {
        let now = new Date();
        let durationMin = (now - this.$store.state.appSessionIDModifiedTime) / 1000 / 60;
        if (durationMin > 5) {
          let n_appSessionID = await this.rest_getSessionId();
          this.$store.state.appSessionIDModifiedTime = now;
          if (n_appSessionID != this.$store.state.appSessionID) {
            valid = false;
          }
        }
      }
      if (!valid) {
        if (this.$appMode == 1) {
          await this.initApp();
          valid = true;
        } else {
          this.$root.messageDialog(this.$t("session_expired"), "", this.$t("page_reloading"));
          setTimeout(() => window.location.reload(), 2000);
        }
      }
      return valid;
    },

    async dispatchAction(actionName, payload) {
      const valid = await this.isSessionValid();
      if (!valid) return null;

      return this.$store.dispatch(actionName, payload);
    },

    initApp() {
      return new Promise(resolve => {
        this.$store.state.launchTime = new Date();
        this.rest_initApp(this.$store.state.appToken)
          .then(res_initApp => {
            if (res_initApp.result == "ok") {
              this.$store.state.appSessionID = res_initApp.sessionId;
              this.$store.state.appSessionKey = res_initApp.sessionKey;
              this.rest_getStores().then(res_getStores => {
                if (res_getStores.result == "ok") {
                  this.$store.state.companyName = res_getStores.companyName;
                  this.$store.commit("stores", {
                    list: res_getStores.stores,
                  });

                  this.$store.state.service = res_getStores.service;
                  if (this.$store.state.service == null) this.$store.state.service = {};
                  if (this.$store.state.service.sessionKey == null)
                    this.$store.state.service.sessionKey = res_initApp.sessionKey;

                  if (this.$appMode == 1 && res_getStores.test != null) {
                    if (Array.isArray(res_getStores.test)) {
                      for (let t of res_getStores.test) {
                        if (
                          t.appId == this.$store.getters.appName &&
                          t.buildNo == this.$store.getters.appVersion.buildNo &&
                          t.phoneNo != null &&
                          t.phoneNo.length == 10
                        ) {
                          this.$store.state.testMode = true;
                          this.$store.state.testPhoneNo = t.phoneNo;
                          break;
                        }
                      }
                    }
                  }
                  console.log("testMode", this.$store.state.testMode, this.$store.state.testPhoneNo);

                  this.setTheme(res_getStores.theme);

                  this.$store.state.memberEnabled = true;
                  this.$store.state.memberOptional = false;
                  this.$store.state.pointEnabled = false;
                  this.$store.state.giftcardEnabled = false;
                  if (res_getStores.service != null) {
                    let service = res_getStores.service;
                    if (service.sessionKey != null) {
                      if (service.pointEnabled != null) this.$store.state.pointEnabled = service.pointEnabled;
                      if (service.giftcardEnabled != null) this.$store.state.giftcardEnabled = service.giftcardEnabled;
                    }
                  }
                  this.$store.state.store = null;
                  //this.$store.state.storeCurrentRoute = null;
                  if (
                    ["MenuFull", "MenuCategory", "MenuItem", "Order", "OrderBundle", "Checkout", "Payment"].includes(
                      this.$router.currentRoute.name
                    )
                  ) {
                    this.navOrder();
                  }
                  resolve(true);
                } else {
                  resolve(false);
                }
              });
            } else {
              resolve(false);
            }
          })
          .catch(error => {
            console.log(error);
            resolve(false);
          });
      });
    },

    navPath(path, query) {
      if (this.$router.currentRoute.path != path) {
        this.$router.push({
          path: path,
          query: query,
        });
      }
    },

    navName(name, params) {
      if (this.$appMode == 1) {
        let pushRoute = false;
        if (this.$router.currentRoute.name != name) pushRoute = true;
        else if (this.$router.currentRoute.name == "MenuCategory") {
          pushRoute = this.$router.currentRoute.params.catID != params.catID;
        } else if (this.$router.currentRoute.name == "Stores") {
          let o_nextRouteName =
            this.$router.currentRoute.params == null ? null : this.$router.currentRoute.params.nextRouteName;
          let n_nextRouteName = params == null ? null : params.nextRouteName;
          pushRoute = o_nextRouteName != n_nextRouteName;
        }
        if (pushRoute) {
          if (
            name == "Stores" ||
            name == "MenuFull" ||
            name == "MenuCategory" /* || name == "Order" || name == "OrderBundle"*/
          ) {
            this.$store.state.appTabBarIndex = 1;
          }

          this.$router
            .push({
              name: name,
              params: params,
            })
            .catch(() => {});
        }
      } else {
        if (
          this.$router.currentRoute.name != name ||
          (this.$router.currentRoute.name == "MenuCategory" && this.$router.currentRoute.params.catID != params.catID)
        ) {
          this.$router.push({
            name: name,
            params: params,
          });
        }
      }
    },

    navHome() {
      this.navName(this.$store.state.rootName);
    },

    navOrder() {
      /*
      let routeName = "Stores";
      if (this.$store.state.storeCurrentRoute != null) {
        routeName = this.$store.state.storeCurrentRoute.name;
      }
      if (this.$store.state.store != null && routeName == "Stores") {
        routeName = "MenuFull";
      }
      if (routeName == "MenuFull") this.navMenu();
      else this.navName(routeName);
      */
      let lastLaunchTime = this.getLaunchTime();
      let now = new Date();
      let launchMin = (now - lastLaunchTime) / 1000 / 60;

      if (this.$store.state.store != null && launchMin < 120) this.navMenu();
      else this.navName("Stores");
    },

    navOffer() {
      this.navName("Offer");
    },

    async navMenu(params) {
      if (this.$appMode == 1) {
        let orderType = this.$store.state.OT_TAKEOUT;
        if (params != null) {
          if (params.orderType != null) {
            if (
              [this.$store.state.OT_DINEIN, this.$store.state.OT_TAKEOUT, this.$store.state.OT_DELIVERY].includes(
                params.orderType
              )
            )
              orderType = params.orderType;
          }
        } else {
          orderType = this.$store.state.order.orderType;
        }
        let switchOrderType = true;
        let om = this.$store.getters.storeOrderType(orderType);

        let o_priceLevel = this.$store.state.order.priceLevel;
        let n_priceLevel = 0;
        if (om != null && om.priceLevel != null && Number.isInteger(om.priceLevel)) n_priceLevel = om.priceLevel;

        if (this.$store.state.order.orderItems.length > 0) {
          if (o_priceLevel != n_priceLevel) {
            switchOrderType = await this.$root.confirmDialog(
              this.$t("confirm_title_switch_ordertype") + this.$t(orderType) + "?",
              "",
              this.$t("confirm_leave_clear_cart"),
              { yesText: this.$t("confirm_button_switch") }
            );
          } else {
            if (orderType == this.$store.state.OT_DINEIN) {
              let promoOi = this.$store.state.order.orderItems.find(x => x.promo != null);
              if (promoOi != null) {
                switchOrderType = await this.$root.confirmDialog(
                  this.$t("confirm_title_switch_ordertype") + this.$t(orderType) + "?",
                  "",
                  this.$t("confirm_leave_remove_promo_cart"),
                  { yesText: this.$t("confirm_button_switch") }
                );
              }
            }
          }
        }

        if (switchOrderType) {
          let res = await this.setOrderType(orderType);
          if (res) {
            if (this.$store.getters.categoryPosition == "center") this.navName("MenuCategory", params);
            else this.navName("MenuFull", params);
          }
        }
      } else {
        if (this.$store.state.rootName == "Stores" || this.$store.state.rootName == "StoreHome") {
          if (this.$store.getters.categoryPosition == "center") {
            this.navName("MenuCategory");
          } else {
            this.navName("MenuFull");
          }
        } else {
          this.navHome();
        }
      }
    },

    navBack() {
      if (this.$appMode == 1) {
        if (this.$router.currentRoute.name == "StoreHome") {
          this.navName("Stores");
        } else if (this.$router.currentRoute.name == "MenuFull") {
          this.navName("Stores");
        } else if (this.$router.currentRoute.name == "MenuCategory" && this.$router.currentRoute.params.catID == null) {
          this.navName("Stores");
        } else {
          this.$router.back();
        }
      } else {
        if (this.$router.currentRoute.name == "StoreHome" && this.$store.state.rootName == "Stores") {
          this.navName("Stores");
          //this.$router.back();
        } else if (
          this.$router.currentRoute.name == "MenuFull" &&
          (this.$store.state.rootName == "Stores" || this.$store.state.rootName == "StoreHome")
        ) {
          this.navName("StoreHome");
          //this.$router.back();
        } else if (
          this.$router.currentRoute.name == "MenuCategory" &&
          this.$router.currentRoute.params.catID === undefined &&
          (this.$store.state.rootName == "Stores" || this.$store.state.rootName == "StoreHome")
        ) {
          this.navName("StoreHome");
          //this.$router.back();
        } else {
          this.$router.back();
        }
      }
    },

    setLanguage(language) {
      this.$store.state.languageSelected = language;
      this.$i18n.locale = language.locale;

      this.$store.state.descrIndex = 0;
      if (this.$store.state.languageSelected != null && this.$store.state.languageSelected.descrIndex != null) {
        this.$store.state.descrIndex = this.$store.state.languageSelected.descrIndex;
      }

      if (this.$appMode == 1) {
        this.setLanguageIdToStorage(language.id);
      }
    },

    getLanguageIdFromStorage() {
      let id = 0;
      let key = "LNG_" + this.keyCompanyCode;
      if (localStorage.getItem(key)) {
        id = localStorage.getItem(key);
      }
      return id;
    },

    setLanguageIdToStorage(id) {
      let key = "LNG_" + this.keyCompanyCode;
      localStorage.setItem(key, id);
    },

    getOrderFromStorage() {
      let order = null;
      let key = "ORD_" + this.$store.getters.storeCompanyCode;
      if (localStorage.getItem(key)) {
        order = JSON.parse(localStorage.getItem(key));
        order.orderUUID = uuidv4();
      }

      return order;
    },

    setOrderToStorage(order) {
      try {
        if (order == null) {
          this.$store.state.order.lastUpdated = Date.now();
          order = this.$store.state.order;
        }

        let key = "ORD_" + this.$store.getters.storeCompanyCode;
        localStorage.setItem(key, JSON.stringify(order));
      } catch (error) {
        console.log(error);
      }
    },

    async loadOrderHistory() {
      console.log("orderHistoryOnCloud", this.$store.getters.orderHistoryOnCloud);

      let orderHistory = [];
      let orderUUIDs = [];
      if (this.$store.state.member != null) {
        let phoneNo = this.$store.state.member.PhoneId.substr(2, 10);
        let resp = await this.rest_getOrders(phoneNo);
        if (resp.result == "ok") {
          resp.orders.forEach(o => {
            let ele = { feed: o, referenceID: o.referenceID, time: o.checkoutTimeTz };
            orderHistory.push(ele);
            orderUUIDs.push(o.orderUUID);
          });
        }
      }

      let localOrderHistory = this.getOrderHistory();
      localOrderHistory.forEach(ele => {
        let foundEle = orderHistory.find(x => x.feed.orderUUID == ele.feed.orderUUID);
        if (foundEle == null) {
          orderHistory.push(ele);
          orderUUIDs.push(ele.feed.orderUUID);
        }
      });

      orderHistory.sort(function(a, b) {
        if (a.time > b.time) return -1;
        if (b.time > a.time) return 1;
      });

      this.$store.state.orderHistory = orderHistory;

      console.log("orderHistory", this.$store.state.orderHistory);
    },

    getOrderHistory() {
      let orderHistory = [];
      let key = "OHX_" + this.$store.getters.storeCompanyCode;
      if (localStorage.getItem(key)) {
        this.$store.state.orderHistory = [];
        orderHistory = JSON.parse(localStorage.getItem(key));
        orderHistory.forEach(element => {
          if (element.order != null && element.feed == null) {
            let feed = this.orderToFeed(element.order);
            this.$set(element, "feed", feed);
          }
        });
      }

      console.log("local orderHistory", orderHistory);
      return orderHistory;
    },

    // add order to local history
    addOrderHistory(referenceID) {
      try {
        let orderHistory = this.getOrderHistory();
        if (orderHistory.length >= 20) orderHistory.pop();

        let key = "OHX_" + this.$store.getters.storeCompanyCode;
        let ord = {
          time: new Date().toISOString(),
          referenceID: referenceID,
          order: this.$store.state.order,
          feed: this.orderToFeed(this.$store.state.order),
        };
        orderHistory.unshift(ord);
        localStorage.setItem(key, JSON.stringify(orderHistory));
      } catch (error) {
        console.log(error);
      }
    },

    // set history to local storage
    setOrderHistory(orders) {
      let key = "OHX_" + this.$store.getters.storeCompanyCode;
      localStorage.setItem(key, JSON.stringify(orders));
    },

    // clear history from local storage
    clearOrderHistory() {
      try {
        let key = "OHX_" + this.$store.getters.storeCompanyCode;
        this.$store.state.orderHistory = [];
        localStorage.setItem(key, JSON.stringify(this.$store.state.orderHistory));
      } catch (error) {
        console.log(error);
      }
    },

    loadAddressList() {
      this.$store.state.addressList = [];

      let key = "ADR_" + this.keyCompanyCode;
      if (localStorage.getItem(key)) {
        this.$store.state.addressList = JSON.parse(localStorage.getItem(key));
      }
    },

    saveAddressList(addressList) {
      if (addressList === undefined) {
        addressList = this.$store.state.addressList;
      }
      let key = "ADR_" + this.keyCompanyCode;
      localStorage.setItem(key, JSON.stringify(addressList));
    },

    initOrder() {
      this.$store.state.order = {
        orderUUID: uuidv4(),
        orderType: this.$store.state.OT_TAKEOUT,
        tableID: 0,
        tableName: "",
        tableGroupID: 0,
        tableGroupName: "",
        phoneID: "",
        memberCode: "",
        login: null,
        /*
        login:
          this.$appMode == 1
            ? {
                name: this.$store.getters.memberFullName,
                firstName: this.$store.state.member.MemberFirstName,
                lastName: this.$store.state.member.MemberLastName,
                phone1: this.$store.state.member.PhoneId.substring(2),
                phoneVerified: true,
                isMember: true,
              }
            : undefined,
            */
        orderItems: [],
        currency: this.$store.state.paymentCurrency,
        defaultDiscountRate: 0,
        defaultServiceValue: 0,
        defaultServicePercentage: true,
        subtotal: 0,
        deliveryValue: 0,
        deliveryValueByAddress: 0,
        deliveryWithhold: 0,
        discountRate: 0,
        discountValue: 0,
        serviceRate: 0,
        serviceValue: 0,
        tax: 0,
        tips: 0,
        total: 0,
        qtyTotal: 0,
        redeemedPointsTotal: 0,
        payAmount: 0,
        payData: null,
        address: null,
        dineInAway: false,
        checkoutTime: null,
        pickupTime: null,
        deliveryTime: null,
        deliveryTimeTo: null,
        memo: "",
        minOrder: 0,
        minOrderForFreeDelivery: 0,
        utensils: this.$store.state.utensils,
        priceLevel: 0,
        distance: 0,
        payment: "skip",
        lastUpdated: Date.now(),
        cbRefIDs: [],
        orderNow: true,
      };

      //this.$store.state.cbRefCounter = 1;
      //this.$store.state.orderedCounter = [];
      this.setOrderToStorage();
    },

    setOrderType(orderType) {
      return new Promise(resolve => {
        let o_orderType = this.$store.state.order.orderType;
        let o_priceLevel = this.$store.state.order.priceLevel;
        this.$store.state.order.orderType = orderType;
        try {
          let om = this.$store.getters.storeOrderType(orderType);

          if (om !== undefined) {
            if (om.distance !== undefined) this.$store.state.order.distance = om.distance;
            else this.$store.state.order.distance = 0;

            if (om.discountRate !== undefined) this.$store.state.order.defaultDiscountRate = om.discountRate;
            else this.$store.state.order.defaultDiscountRate = 0;

            if (om.serviceValue !== undefined) this.$store.state.order.defaultServiceValue = om.serviceValue;
            else this.$store.state.order.defaultServiceValue = 0;
            if (om.servicePercentage !== undefined)
              this.$store.state.order.defaultServicePercentage = om.servicePercentage;
            else this.$store.state.order.defaultServicePercentage = true;

            if (om.payment !== undefined) this.$store.state.order.payment = om.payment;

            if (om.minOrder !== undefined) this.$store.state.order.minOrder = om.minOrder;
            else this.$store.state.order.minOrder = 0;

            if (om.minOrderForFreeDelivery !== undefined)
              this.$store.state.order.minOrderForFreeDelivery = om.minOrderForFreeDelivery;
            else this.$store.state.order.minOrderForFreeDelivery = 0;

            if (om.priceLevel !== undefined && Number.isInteger(om.priceLevel))
              this.$store.state.order.priceLevel = om.priceLevel;
            else this.$store.state.order.priceLevel = 0;
          }

          if (this.$store.getters.doorDashEnabled) {
            this.$store.state.order.paymentTips = this.cloneObject(this.$store.state.doorDashTips);
          } else {
            this.$store.state.order.paymentTips = this.cloneObject(this.$store.state.paymentTips);
            this.$store.state.order.doorDashDriveID = undefined;
          }

          if (
            this.$store.state.menu.length == 0 ||
            o_orderType != this.$store.state.order.orderType ||
            o_priceLevel != this.$store.state.order.priceLevel
          ) {
            this.reloadMenu().then(() => {
              if (o_priceLevel != this.$store.state.order.priceLevel) {
                this.$store.state.order.orderItems = [];
              } else {
                let exItems = [];
                this.$store.state.order.orderItems.forEach(oi => {
                  if (
                    (oi.item.catMenuTypes != null && !oi.item.catMenuTypes.includes(orderType)) ||
                    (oi.item.menuTypes != null && !oi.item.menuTypes.includes(orderType)) ||
                    (oi.promo != null &&
                      (orderType == this.$store.state.OT_DINEIN ||
                        (oi.promo.CustomData != null &&
                          oi.promo.CustomData.OrderTypes != null &&
                          !oi.promo.CustomData.OrderTypes.includes(orderType))))
                  ) {
                    exItems.push(oi);
                  } else if (oi.bundleItems.length > 0) {
                    for (let bi of oi.bundleItems) {
                      if (!bi.orderItem.item.menuTypes.includes(orderType)) {
                        exItems.push(oi);
                        break;
                      }
                    }
                  }
                });

                if (exItems.length > 0) {
                  exItems.forEach(oi => {
                    this.removeOrderItem(oi);
                  });
                }
              }

              this.calculateTotal();
              this.setOrderToStorage();
              resolve(true);
            });
          } else {
            resolve(true);
          }
        } catch (error) {
          console.log(error);
          resolve(false);
        }
      });
    },

    updateNewsFeeds() {
      this.rest_getNewsFeed().then(resp => {
        //console.log(resp);
        if (resp != null && resp.result == "ok") {
          let newsFeeds = resp.record;
          newsFeeds.forEach(nf => {
            let title = nf.Titles.def;
            let title1 = title;
            let title2 = title;
            let content = nf.Contents.def;
            let content1 = content;
            let content2 = content;

            this.$store.getters.languages.forEach(lang => {
              let nfLangTitle = nf.Titles[lang.locale];
              if (nfLangTitle != null && nfLangTitle != "") {
                if (lang.descrIndex == 0) title = nfLangTitle;
                else if (lang.descrIndex == 1) title1 = nfLangTitle;
                else if (lang.descrIndex == 2) title2 = nfLangTitle;
              }

              let nfLangContent = nf.Contents[lang.locale];
              if (nfLangContent != null && nfLangContent != "") {
                if (lang.descrIndex == 0) content = nfLangContent;
                else if (lang.descrIndex == 1) content1 = nfLangContent;
                else if (lang.descrIndex == 2) content2 = nfLangContent;
              }
            });

            this.$set(nf, "title", title);
            this.$set(nf, "title1", title1);
            this.$set(nf, "title2", title2);
            this.$set(nf, "content", content);
            this.$set(nf, "content1", content1);
            this.$set(nf, "content2", content2);
          });
          this.$store.state.newsFeeds = newsFeeds;
        } else {
          this.$store.state.newsFeeds = [];
        }
      });
    },

    updateMemberPromos(memberCode, companyCode) {
      return new Promise(resolve => {
        this.getMemberPromos(memberCode, companyCode).then(promos => {
          this.$store.state.promos = promos;
          resolve(true);
        });
      });
    },

    getMemberPromos(memberCode, companyCode) {
      if (companyCode == null && this.$store.state.store != null) {
        companyCode = this.$store.state.store.companyCode;
      }

      return new Promise(resolve => {
        if (this.$store.state.serverBuildNo >= 167 || this.$appMode == 1) {
          this.rest_getMemberPromos(memberCode, companyCode)
            .then(restResult => {
              if (restResult.result == "ok") {
                let promos = restResult.record;
                promos.forEach(promo => {
                  this.addExInfoToPromo(promo);
                });

                resolve(promos);
              } else {
                resolve([]);
              }
            })
            .catch(error => {
              console.log(error);
              resolve([]);
            });
        } else {
          resolve([]);
        }
      });
    },

    addExInfoToPromo(promo) {
      if (promo == null) return;

      let title = promo.Titles.def;
      let title1 = title;
      let title2 = title;
      let detail = promo.Descriptions.def;
      let detail1 = detail;
      let detail2 = detail;

      this.$store.getters.languages.forEach(lang => {
        let promoLangTitle = promo.Titles[lang.locale];
        if (promoLangTitle != null && promoLangTitle != "") {
          if (lang.descrIndex == 0) title = promoLangTitle;
          else if (lang.descrIndex == 1) title1 = promoLangTitle;
          else if (lang.descrIndex == 2) title2 = promoLangTitle;
        }

        let promoLangDetail = promo.Descriptions[lang.locale];
        if (promoLangDetail != null && promoLangDetail != "") {
          if (lang.descrIndex == 0) detail = promoLangDetail;
          else if (lang.descrIndex == 1) detail1 = promoLangDetail;
          else if (lang.descrIndex == 2) detail2 = promoLangDetail;
        }
      });

      this.$set(promo, "title", title);
      this.$set(promo, "title1", title1);
      this.$set(promo, "title2", title2);
      this.$set(promo, "detail", detail);
      this.$set(promo, "detail1", detail1);
      this.$set(promo, "detail2", detail2);
    },

    async validatePromo(promo) {
      if (!this.$store.getters.acceptOrder) {
        this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
        return false;
      }

      if (promo.ValidFrom != null) {
        let validFrom = this.toDate(promo.ValidFrom);
        console.log(validFrom);
        let today = new Date();
        console.log(today);
        if (validFrom > today) {
          this.$root.messageDialog(
            this.$t("error_alert_title"),
            "",
            this.$t("promo_valid_from", {
              valid_from: validFrom.toLocaleDateString(),
            })
          );
          return false;
        }
      }

      let allowMultiPromo = false;
      if (allowMultiPromo) {
        if (promo.TargetType == "subtotal") {
          let promoSubOi = this.$store.state.order.orderItems.find(
            oi => oi.promo != null && oi.promo.TargetType == "subtotal"
          );
          if (promoSubOi != null) {
            this.$root.messageDialog(this.$t("error_alert_title"), "", this.$t("promo_one_an_order"));
            return false;
          }
        }
      } else {
        let promoOi = this.$store.state.order.orderItems.find(oi => oi.promo != null);
        if (promoOi != null) {
          this.$root.messageDialog(this.$t("error_alert_title"), "", this.$t("promo_one_an_order"));
          return false;
        }
      }

      if (this.$store.state.member == null) {
        let logined = await this.$root.memberLoginDialog(this.$t("login.to_claim_coupon"));
        if (logined) {
          let memberCode = this.$store.state.member.MemberCode;
          let promos = await this.getMemberPromos(memberCode);
          if (promos.length > 0) {
            let _promo = promos.find(p => p.PromoteCode == promo.PromoteCode);
            if (_promo == null) {
              this.$root.messageDialog(
                this.$t("error_alert_title"),
                "",
                this.$t("error_promo_redeemed", { promo: promo.Title })
              );
              return false;
            }
          } else {
            this.$root.messageDialog(this.$t("error_alert_title"), "", this.$t("error_promo_get"));
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    },

    addPromoToCart(promo) {
      console.log("addPromoToCart.promo", promo);

      let item = {
        ID: 0,
        descr: promo.title,
        descr1: promo.title1,
        descr2: promo.title2,
        detail: promo.detail,
        detail1: promo.detail1,
        detail2: promo.detail2,
        price: 0,
        gst: true,
        pst: true,
        liq: false,
        bItems: null,
        itemDiscountable: false,
        itemDiscountRate: 0,
        itemDiscountValue: 0,
        discountable: true,
        promo: promo,
      };

      let customData = promo.CustomData;
      if (customData.BillDiscountable != null) item.discountable = customData.BillDiscountable;

      let buyQty = 1;
      if (promo.BuyRatio != null && typeof promo.BuyRatio == "number") buyQty = promo.BuyRatio;
      if (buyQty <= 0) buyQty = 1;
      let buySingle = customData.BuySingle == null ? false : customData.BuySingle;

      let getQty = 1;
      if (promo.GetRatio != null && typeof promo.GetRatio == "number") getQty = promo.GetRatio;
      if (getQty <= 0) getQty = 1;
      let getSingle = customData.GetSingle == null ? false : customData.GetSingle;

      let buyDiscountRate = 0;
      let buyDiscountValue = 0;
      let getDiscountRate = 0;
      let getDiscountValue = 0;
      if (promo.TargetType == "item") {
        if (promo.DiscValue != null && typeof promo.DiscValue == "number") {
          if (promo.DiscByPercentage == null || promo.DiscByPercentage) getDiscountRate = promo.DiscValue;
          else getDiscountValue = promo.DiscValue;
        }
        if (customData.GetProducts == null && customData.GetGroups == null) {
          buyDiscountRate = getDiscountRate;
          buyDiscountValue = getDiscountValue;
        }
      }

      item.bItems = [];

      if (customData.BuyProducts != null) {
        let bItem = null;
        let itemCodes;
        if (customData.BuyProducts.length == 1) {
          let barcode = customData.BuyProducts[0];
          bItem = this.$store.state.items.find(i => i.barcode != "" && i.barcode == barcode);
        } else {
          itemCodes = customData.BuyProducts;
          bItem = {
            ID: 0,
            descr: "?",
            descr1: "?",
            descr2: "?",
            price: 0,
            gst: true,
            pst: true,
            liq: false,
            itemDiscountable: true,
            billDiscountable: true,
          };
        }
        if (bItem != null) {
          let loopCount;
          let qty;

          if (buySingle) {
            loopCount = 1;
            qty = buyQty;
          } else {
            loopCount = buyQty;
            qty = 1;
          }

          for (let ii = 0; ii < loopCount; ii++) {
            let bi = {
              applyDiff: "all",
              itemCodes: itemCodes,
              qty: qty,
              itemDiscountRate: buyDiscountRate,
              itemDiscountValue: buyDiscountValue,
              item: bItem,
            };
            item.bItems.push(bi);
          }
        }
      } else if (customData.BuyGroups != null && customData.BuyGroups.length > 0) {
        let loopCount;
        let qty;

        if (buySingle) {
          loopCount = 1;
          qty = buyQty;
        } else {
          loopCount = buyQty;
          qty = 1;
        }

        for (let ii = 0; ii < loopCount; ii++) {
          let bi = {
            applyDiff: "all",
            catCodes: customData.BuyGroups,
            qty: qty,
            itemDiscountRate: buyDiscountRate,
            itemDiscountValue: buyDiscountValue,
            item: {
              ID: 0,
              descr: "?",
              descr1: "?",
              descr2: "?",
              price: 0,
              gst: true,
              pst: true,
              liq: false,
              itemDiscountable: true,
              billDiscountable: true,
            },
          };
          item.bItems.push(bi);
        }
      }

      if (customData.GetProducts != null && customData.GetProducts.length > 0) {
        let bItem = null;
        let itemCodes;
        if (customData.GetProducts.length == 1) {
          let barcode = customData.GetProducts[0];
          bItem = this.$store.state.items.find(i => i.barcode != "" && i.barcode == barcode);
        } else {
          itemCodes = customData.GetProducts;
          bItem = {
            ID: 0,
            descr: "?",
            descr1: "?",
            descr2: "?",
            price: 0,
            gst: true,
            pst: true,
            liq: false,
            itemDiscountable: true,
            billDiscountable: true,
          };
        }
        if (bItem != null) {
          let loopCount;
          let qty;

          if (getSingle) {
            loopCount = 1;
            qty = getQty;
          } else {
            loopCount = getQty;
            qty = 1;
          }

          for (let ii = 0; ii < loopCount; ii++) {
            let bi = {
              applyDiff: "all",
              itemCodes: itemCodes,
              qty: qty,
              itemDiscountRate: getDiscountRate,
              itemDiscountValue: getDiscountValue,
              item: bItem,
            };
            item.bItems.push(bi);
          }
        }
        /*
            for (let prod of customData.GetProducts) {
              let bItem = this.$store.state.items.find(i => i.barcode != "" && i.barcode == prod);
              if (bItem != null) {
                let bi = {
                  applyDiff: "all",
                  qty: getQty,
                  itemDiscountRate: getDiscountRate,
                  itemDiscountValue: getDiscountValue,
                  item: bItem,
                };
                item.bItems.push(bi);
                break;
              }
            }
            */
      } else if (customData.GetGroups != null && customData.GetGroups.length > 0) {
        let loopCount;
        let qty;
        if (getQty > 0) {
          if (getSingle) {
            loopCount = 1;
            qty = getQty;
          } else {
            loopCount = getQty;
            qty = 1;
          }
        }

        for (let ii = 0; ii < loopCount; ii++) {
          let bi = {
            applyDiff: "all",
            catCodes: customData.GetGroups,
            qty: qty,
            itemDiscountRate: getDiscountRate,
            itemDiscountValue: getDiscountValue,
            item: {
              ID: 0,
              descr: "?",
              descr1: "?",
              descr2: "?",
              price: 0,
              gst: true,
              pst: true,
              liq: false,
              itemDiscountable: true,
              billDiscountable: true,
            },
          };
          item.bItems.push(bi);
        }

        /*
            if (customData.GetSingle != null && customData.GetSingle) {
              let bi = {
                applyDiff: "all",
                catCodes: customData.GetGroups,
                qty: getQty,
                itemDiscountRate: getDiscountRate,
                itemDiscountValue: getDiscountValue,
                item: {
                  ID: 0,
                  descr: "?",
                  descr1: "?",
                  descr2: "?",
                  price: 0,
                  gst: true,
                  pst: true,
                  liq: false,
                  itemDiscountable: true,
                  billDiscountable: true,
                },
              };
              item.bItems.push(bi);
            } else {
              for (let ii = 0; ii < getQty; ii++) {
                let bi = {
                  applyDiff: "all",
                  catCodes: customData.GetGroups,
                  qty: 1,
                  itemDiscountRate: getDiscountRate,
                  itemDiscountValue: getDiscountValue,
                  item: {
                    ID: 0,
                    descr: "?",
                    descr1: "?",
                    descr2: "?",
                    price: 0,
                    gst: true,
                    pst: true,
                    liq: false,
                    itemDiscountable: true,
                    billDiscountable: true,
                  },
                };
                item.bItems.push(bi);
              }
            }
            */
      }

      if (/*promo.TargetType == "subtotal" && */ typeof promo.DiscValue == "number") {
        if (promo.DiscByPercentage != null && !promo.DiscByPercentage) {
          if (promo.MinAmount == null || promo.MinAmount < promo.DiscValue) {
            this.$set(promo, "MinAmount", promo.DiscValue);
          }
        }
      }

      console.log("addPromoToCart.item", item);

      if (item.bItems.length > 0) {
        let params = { item: item };
        this.navName("OrderBundle", params);
      } else {
        let oi = this.itemToOrderItem(item);
        this.addOrderItem(oi);
      }
    },

    async setStore(store) {
      this.$store.state.store = store;
      if (store.info != null) {
        let storeCoordsLat = null;
        let storeCoordsLng = null;
        if (store.coords !== undefined) {
          storeCoordsLat = store.coords.lat;
          storeCoordsLng = store.coords.lng;
        }

        if (storeCoordsLat == null || storeCoordsLng == null) {
          if (this.storeAddressString != "") {
            let getCoordsResult = await this.getCoords(this.storeAddressString);
            this.storeCoords = getCoordsResult.coords;
          }
        } else {
          this.storeCoords = store.coords;
        }
      }
    },

    refreshStores(getMyPosition) {
      this.$store.state.stores.list.forEach(store => {
        try {
          let timeStatus = this.getStoreTimeStatus(store);
          this.$set(store, "timeStatus", timeStatus);
        } catch (error) {
          console.log(error);
        }
      });

      let currentTime = new Date();
      if (getMyPosition == null)
        getMyPosition =
          this.positionGetTime == null || (currentTime.getTime() - this.positionGetTime.getTime()) / 1000 / 60 > 1;

      if (getMyPosition) {
        this.getMyCoords()
          .then(myCoords => {
            this.positionGetTime = new Date();

            this.$store.state.myCoords = myCoords;
            if (this.$store.state.myCoords != null) {
              this.$store.state.stores.list.forEach(store => {
                if (store.coords != null) {
                  let storeCoords = {
                    latitude: store.coords.lat,
                    longitude: store.coords.lng,
                  };

                  let distance = this.getDistance(myCoords, storeCoords);
                  //console.log(distance);
                  this.$set(store, "distanceBetween", distance);
                }
              });

              this.sortStores();
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    sortStores() {
      this.$store.state.stores.list.sort(
        (a, b) =>
          (a.distanceBetween == null ? 0 : a.distanceBetween) - (b.distanceBetween == null ? 0 : b.distanceBetween)
      );
    },

    async storeSelected(store, option) {
      console.log("store, option", store, option);

      if (store.info.fullInfo != null && !store.info.fullInfo) {
        let resp = await this.rest_getStore(store.sessionKey);
        if (resp != null && resp.result == "ok") {
          store = Object.assign(store, resp.store);
        } else return false;
      }

      let ok = true;

      // init config
      this.$store.state.orderLimitPerPeriod = 0;
      this.$store.state.orderLimitSkipValue = 0;
      this.$store.state.menuImageVisible = "show";
      this.$store.state.menuImageAlignment = "left";
      this.$store.state.itemFastAdd = false;
      this.$store.state.notAskUtensils = false;
      this.$store.state.utensils = true;
      this.$store.state.alwaysSendPickupTime = false;
      this.$store.state.addressLookupEnabled = true;
      this.$store.state.memoAsBillMemo = false;
      this.$store.state.showItemBarcode = false;
      this.$store.state.showItemImageInOrder = false;
      this.$store.state.ordDidCount = 1;
      this.$store.state.promos = [];
      this.$store.state.sideComboTags = [];
      this.$store.state.mainMenu = [];
      this.$store.state.menu = [];
      this.$store.state.orderMenu = 0;

      if ("config" in store) {
        if ("orderLimitPerPeriod" in store.config) {
          this.$store.state.orderLimitPerPeriod = store.config.orderLimitPerPeriod;
        }
        if ("orderLimitSkipValue" in store.config) {
          this.$store.state.orderLimitSkipValue = store.config.orderLimitSkipValue;
        }

        if ("menuImageVisible" in store.config) {
          this.$store.state.menuImageVisible = store.config.menuImageVisible;
        } else if ("hideMenuImage" in store.config) {
          this.$store.state.menuImageVisible = store.config.hideMenuImage ? "hide" : "show";
        }

        if ("menuImageAlignment" in store.config) {
          this.$store.state.menuImageAlignment = store.config.menuImageAlignment;
        }

        if ("itemFastAdd" in store.config) {
          this.$store.state.itemFastAdd = store.config.itemFastAdd;
        }

        if ("notAskUtensils" in store.config) {
          this.$store.state.notAskUtensils = store.config.notAskUtensils;
        }

        if ("utensils" in store.config) {
          this.$store.state.utensils = store.config.utensils;
        }

        if ("alwaysSendPickupTime" in store.config) {
          this.$store.state.alwaysSendPickupTime = store.config.alwaysSendPickupTime;
        }

        if ("memoAsBillMemo" in store.config) {
          this.$store.state.memoAsBillMemo = store.config.memoAsBillMemo;
        }

        if ("showItemBarcode" in store.config) {
          this.$store.state.showItemBarcode = store.config.showItemBarcode;
        }

        if ("showItemImageInOrder" in store.config) {
          this.$store.state.showItemImageInOrder = store.config.showItemImageInOrder;
        }

        if ("verifyPhoneNumber" in store.config) {
          this.$store.state.verifyPhoneNumber = store.config.verifyPhoneNumber;
        }
      }

      // payment
      this.$store.state.paymentCurrency = "CAD";
      if (store.checkout != null && store.checkout.currency != null) {
        if (store.checkout.currency != "") this.$store.state.paymentCurrency = store.checkout.currency;
      }

      this.$store.state.paymentTips = [];
      if (store.checkout != null && store.checkout.tips != null) {
        //console.log(store.checkout.tips);
        let tipsDefed = false;
        store.checkout.tips.forEach(tipsEle => {
          let tipsTitle = "";
          let tipsDef = false;
          let tipsDollar = false;
          let tipsCustom = false;
          let tipsValue = 0;
          if (isNaN(tipsEle)) {
            let numMatch = tipsEle.match(this.$store.state.numberPattern);
            if (numMatch != null && numMatch.length > 0) {
              tipsValue = Number(numMatch[0]);
            }

            tipsDef = !tipsDefed && tipsEle.includes("!");
            if (tipsDef) tipsDefed = true;

            tipsDollar = tipsEle.includes("$");
            tipsCustom = tipsEle.includes("*");
          } else {
            tipsValue = tipsEle;
          }

          if (tipsCustom) tipsTitle = "Other";
          else if (tipsDollar) tipsTitle = "$" + tipsValue.toString();
          else tipsTitle = tipsValue.toString() + "%";

          let tipsItem = {
            title: tipsTitle,
            value: tipsValue,
            rate: !tipsDollar,
            checked: tipsDef,
            other: tipsCustom,
          };
          this.$store.state.paymentTips.push(tipsItem);
        });

        if (this.$store.state.paymentTips.length > 0) {
          this.$store.state.paymentTips.unshift({
            title: "No Tips",
            value: 0,
            rate: true,
            checked: tipsDefed ? false : true,
            other: false,
          });
        }
      }

      // language
      let curLanguage;
      if (store.info.languages != null && store.info.languages.length > 0) {
        let languageIndex = 0;
        if (store.config != null) {
          let storeConfig = store.config;
          if (
            storeConfig.languageIndex != null &&
            typeof storeConfig.languageIndex == "number" &&
            store.info.languages.length > storeConfig.languageIndex
          ) {
            languageIndex = storeConfig.languageIndex;
          }
        }

        let lang = store.info.languages[languageIndex];
        if (store.messages != null) {
          let storeMessage = store.messages;

          store.info.languages.forEach(lang => {
            let homeMessage = storeMessage.home != null ? storeMessage.home[lang.locale] : "";
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "home-message": homeMessage,
            });
            let dineinMessage = storeMessage.dinein != null ? storeMessage.dinein[lang.locale] : "";
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "dinein-message": dineinMessage,
            });
            let takeoutMessage = storeMessage.takeout != null ? storeMessage.takeout[lang.locale] : "";
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "takeout-message": takeoutMessage,
            });
            let deliveryMessage = storeMessage.delivery != null ? storeMessage.delivery[lang.locale] : "";
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "delivery-message": deliveryMessage,
            });
            let checkoutMessage = storeMessage.checkout != null ? storeMessage.checkout[lang.locale] : "";
            this.$i18n.mergeLocaleMessage(lang.locale, {
              "checkout-message": checkoutMessage,
            });
          });
        } else {
          this.$i18n.mergeLocaleMessage(lang.locale, { "home-message": "" });
          this.$i18n.mergeLocaleMessage(lang.locale, {
            "dinein-message": "",
          });
          this.$i18n.mergeLocaleMessage(lang.locale, {
            "takeout-message": "",
          });
          this.$i18n.mergeLocaleMessage(lang.locale, {
            "delivery-message": "",
          });
          this.$i18n.mergeLocaleMessage(lang.locale, {
            "checkout-message": "",
          });
        }

        curLanguage = lang;
      } else {
        this.$i18n.locale = "en";
        this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
          "home-message": "",
        });
        this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
          "dinein-message": "",
        });
        this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
          "takeout-message": "",
        });
        this.$i18n.mergeLocaleMessage(this.$i18n.locale, {
          "delivery-message": "",
        });
      }

      if (this.$appMode == 1) {
        this.setLaunchTime();

        this.$store.state.serverBuildNo = 0;
        if (store.sessionKey != null) {
          this.setStore(store);
          await this.rest_getServerStatus().then(res => {
            if (res.buildNo != null) this.$store.state.serverBuildNo = res.buildNo;
            console.log("serverBuildNo", this.$store.state.serverBuildNo);
          });

          this.$store.state.pointRedeemEnabled = false;
          this.$store.state.giftcardPaymentEnabled = false;
          if (store.service != null) {
            let service = store.service;
            if (service.sessionKey != null) {
              if (service.pointRedeemEnabled != null)
                this.$store.state.pointRedeemEnabled = this.$store.state.pointEnabled && service.pointRedeemEnabled;
              if (service.giftcardPaymentEnabled != null)
                this.$store.state.giftcardPaymentEnabled =
                  this.$store.state.giftcardEnabled && service.giftcardPaymentEnabled;
            }
          }

          if (this.$store.state.memberEnabled && this.$store.state.member != null) {
            let memberCode = (memberCode = this.$store.state.member.MemberCode);
            this.updateMemberPromos(memberCode);
          }

          let orderFromStorage = this.getOrderFromStorage();
          if (
            orderFromStorage == null ||
            orderFromStorage.lastUpdated == null ||
            Date.now() - orderFromStorage.lastUpdated > 60 * 60 * 1000
          )
            this.initOrder();
          else {
            this.$store.state.order = orderFromStorage;
            this.$store.state.order.lastUpdated = Date.now();
          }
          this.updateOrderLogin(this.$store.state.member != null);

          let optionTableID = 0;
          let optionOrderType = "";
          if (option != null) {
            if (option.tableID != null) optionTableID = option.tableID;
            if (option.orderType != null) optionOrderType = option.orderType;

            if (optionOrderType == this.$store.state.OT_TAKEOUT || optionOrderType == this.$store.state.OT_DELIVERY)
              optionTableID = 0;
          }

          this.$store.state.order.tableID = 0;
          this.$store.state.order.tableName = "";
          if (optionTableID > 0) {
            await this.rest_getTable({ tableID: optionTableID }).then(res => {
              if (res.result == "ok") {
                let tables = res.tables;
                if (tables.length > 0) {
                  let table = tables[0];

                  this.$store.state.order.orderType = this.$store.state.OT_DINEIN;
                  this.$store.state.order.tableID = table.ID;
                  this.$store.state.order.tableName = table.descr;
                }
              }
            });
          } else if (optionOrderType) {
            if (
              option.orderType == this.$store.state.OT_DINEIN ||
              option.orderType == this.$store.state.OT_TAKEOUT ||
              option.orderType == this.$store.state.OT_DELIVERY
            ) {
              this.$store.state.order.orderType = optionOrderType;
            }
          }

          ok = true;
        }
      } else {
        this.setStore(store);
        await this.rest_getServerStatus().then(res => {
          if (res.buildNo != null) {
            if (res.buildNo != null) this.$store.state.serverBuildNo = res.buildNo;
          }
        });

        this.setLaunchTime();

        let serviceMemberEnabled = false;
        let serviceMemberOptional = false;
        let servicePointEnabled = false;
        let servicePointRedeemEnabled = false;
        let serviceGiftcardEnabled = false;
        let serviceGiftcardPaymentEnabled = false;

        if (store.service != null) {
          let service = store.service;
          if (service.sessionKey != null) {
            if (service.memberEnabled != null) serviceMemberEnabled = service.memberEnabled;
            if (service.memberOptional != null) serviceMemberOptional = service.memberOptional;
            if (service.pointEnabled != null) servicePointEnabled = service.pointEnabled;
            if (service.pointRedeemEnabled != null) servicePointRedeemEnabled = service.pointRedeemEnabled;
            if (service.giftcardEnabled != null) serviceGiftcardEnabled = service.giftcardEnabled;
            if (service.giftcardPaymentEnabled != null) serviceGiftcardPaymentEnabled = service.giftcardPaymentEnabled;
          }
        }

        this.$store.state.descrIndex = 0;

        this.$store.state.languageSelected = null;

        this.$store.state.member = null;

        this.$store.state.memberEnabled = this.$store.getters.serviceSessionKey != null && serviceMemberEnabled;
        this.$store.state.memberOptional = this.$store.state.memberEnabled && serviceMemberOptional;
        this.$store.state.pointEnabled = this.$store.state.memberEnabled && servicePointEnabled;
        this.$store.state.pointRedeemEnabled = this.$store.state.pointEnabled && servicePointRedeemEnabled;
        this.$store.state.giftcardEnabled = this.$store.state.memberEnabled && serviceGiftcardEnabled;
        this.$store.state.giftcardPaymentEnabled = this.$store.state.giftcardEnabled && serviceGiftcardPaymentEnabled;

        this.$store.state.newsFeeds = [];

        if (this.$store.state.memberEnabled) {
          let memberCode = null;

          let lastLogin = await this.getLastLogin();
          if (lastLogin != null) {
            if (lastLogin.isMember) {
              let phoneID = "+1" + lastLogin.phone1.replace(/\D+/g, "");
              let isVerifiedPhoneNumber = await this.isVerifiedPhoneNumber(phoneID);
              if (isVerifiedPhoneNumber) {
                let memberResp = await this.rest_getMember(phoneID);
                if (memberResp.result == "ok") {
                  this.$store.state.member = memberResp.record.child;

                  if (this.$store.state.member != null && this.$store.state.member.MemberCode != null) {
                    memberCode = this.$store.state.member.MemberCode;
                  }

                  this.dispatchAction("getGiftcards");
                }
              }
            }
          }

          this.updateMemberPromos(memberCode);
        }

        if (store.theme != null) {
          this.setTheme(store.theme);
        }

        let orderFromStorage = this.getOrderFromStorage();
        if (
          orderFromStorage == null ||
          orderFromStorage === undefined ||
          Date.now() - orderFromStorage.lastUpdated > 60 * 60 * 1000
        )
          this.initOrder();
        else {
          this.$store.state.order = orderFromStorage;
          this.$store.state.order.lastUpdated = Date.now();
        }

        let optionTableID = 0;
        let optionOrderType = "";
        if (option != null) {
          if (option.tableID != null) optionTableID = option.tableID;
          if (option.orderType) optionOrderType = option.orderType;

          if (optionOrderType == this.$store.state.OT_TAKEOUT || optionOrderType == this.$store.state.OT_DELIVERY)
            optionTableID = 0;
        }

        this.$store.state.order.tableID = 0;
        this.$store.state.order.tableName = "";
        if (optionTableID > 0) {
          await this.rest_getTable({ tableID: optionTableID }).then(res => {
            if (res.result == "ok") {
              let tables = res.tables;
              if (tables.length > 0) {
                let table = tables[0];

                this.$store.state.order.orderType = this.$store.state.OT_DINEIN;
                this.$store.state.order.tableID = table.ID;
                this.$store.state.order.tableName = table.descr;
              }
            }
          });
        } else if (optionOrderType) {
          if (
            option.orderType == this.$store.state.OT_DINEIN ||
            option.orderType == this.$store.state.OT_TAKEOUT ||
            option.orderType == this.$store.state.OT_DELIVERY
          ) {
            this.$store.state.order.orderType = optionOrderType;
          }
        }

        this.loadAddressList();

        if (this.$store.state.rootName != "Stores" && this.$store.state.rootName != "StoreHome") {
          await this.setOrderType(this.$store.state.order.orderType).then(() => {
            console.log("order", this.$store.state.order);
          });
        }

        if (this.$store.getters.storeName != "") document.title = this.$store.getters.storeName;

        if (curLanguage != null) this.setLanguage(curLanguage);
      }

      console.log("storeCompanyCode", this.$store.getters.storeCompanyCode);

      return ok;
    },

    reloadMenu() {
      console.log("reloadMenu");

      return new Promise(resolve => {
        this.$store.state.mainMenu = [];
        this.$store.state.menu = [];
        this.rest_getFullMenu(this.$store.state.order.orderType, this.$store.state.order.priceLevel)
          .then(resp => {
            if (resp.result == "ok") {
              if (resp.categories !== undefined) {
                this.prepareMenu(resp.categories);
                resolve(true);
              }
            } else resolve(false);
          })
          .catch(error => {
            console.log(error);
            resolve(false);
          });
      });
    },

    prepareMenu(menu) {
      let favCat = { ID: -1, pID: 0, imageUris: [], items: [], favorite: true };
      /*
      let rdmCat = {
        ID: -2,
        pID: 0,
        imageUris: [],
        items: [],
        redeemable: true,
      };
      */

      this.$store.state.mainMenu = [];
      this.$store.state.menu = [];
      this.$store.state.items = [];
      this.$store.state.redeemMenu = [];
      this.$store.state.redeemItems = [];
      this.$store.state.sideComboTags = [];

      menu.forEach(cat => {
        let catImageUris = [];
        cat.items.forEach(item => {
          let itemSub = (item.scalable ? item.price * item.weight : item.price) + item.defOptValue;
          this.$set(item, "sub", itemSub);
          if (item.itemDiscountable && item.itemDiscountRate > 0) itemSub = itemSub * (1 - item.itemDiscountRate / 100);
          this.$set(item, "discountedSub", itemSub);
          this.$set(item, "catMenuTypes", cat.menuTypes);
          if (item.scalable && item.weight <= 0) {
            this.$set(item, "orderDisabled", true);
          }
          this.$store.state.items.push(item);

          if (item.imageUri != "") {
            catImageUris.push(item.imageUri);
          }

          if (!item.soldout && !item.disabled) {
            if (item.combos !== undefined) {
              item.combos.forEach(combo => {
                if (this.$store.state.sideComboTags.indexOf(combo.tag) < 0) {
                  this.$store.state.sideComboTags.push(combo.tag);
                }
              });
            }

            if (item.favorite) {
              favCat.items.push(item);
              if (item.imageUri != "") {
                favCat.imageUris.push(item.imageUri);
              }
            }

            if (this.$store.state.pointRedeemEnabled && item.redeemPoints && this.$store.state.serverBuildNo >= 130) {
              let rdmItem = this.cloneObject(item);
              rdmItem.redeemItem = true;
              let rdmCat = this.$store.state.redeemMenu.find(cat => cat.ID == item.catID);
              if (rdmCat == null) {
                rdmCat = this.cloneObject(cat);
                rdmCat.items = [];
                rdmCat.imageUris = [];
                this.$store.state.redeemMenu.push(rdmCat);
              }
              rdmCat.items.push(rdmItem);
              if (rdmItem.imageUri != "") rdmCat.imageUris.push(rdmItem.imageUri);

              if (rdmItem.favorite) {
                let favRdmCat = this.$store.state.redeemMenu.find(cat => cat.ID == -1);
                if (favRdmCat == null) {
                  favRdmCat = { ID: -1, pID: 0, imageUris: [], items: [], favorite: true };
                  this.$store.state.redeemMenu.unshift(favRdmCat);
                }
                favRdmCat.items.push(rdmItem);
                if (rdmItem.imageUri != "") favRdmCat.imageUris.push(rdmItem.imageUri);
              }

              this.$store.state.redeemItems.push(rdmItem);

              /*
              let run = true;
              let x_catID = item.catID;
              while (run) {
                let x_cat = menu.find(cat=>cat.ID == x_catID);
                if (x_cat != null) {
                  if (x_cat.redeemPoints == null) x_cat.redeemPoints = item.redeemPoints;
                  else x_cat.redeemPoints += item.redeemPoints;

                  x_catID = x_cat.pID;
                } else
                  run = false;
              }
              */
              /*
              if (this.$store.state.serverBuildNo >= 130) {
                let nItem = this.cloneObject(item);
                nItem.redeemItem = true;
                rdmCat.items.push(nItem);
                this.$store.state.redeemItems.push(nItem);
                if (item.imageUri != "") {
                  rdmCat.imageUris.push(item.imageUri);
                }
              }
              */
            }
          }
        });

        cat.imageUris = catImageUris;

        if (
          cat.items.length > 0 ||
          this.$store.getters.mainMenuEnabled ||
          this.$store.getters.categoryPosition == "center"
        ) {
          this.$store.state.menu.push(cat);
        }

        /*
        if (this.$store.getters.mainMenuEnabled) {
          if (cat.pID == 0 && cat.menuTypes.includes(this.$store.state.order.orderType)) {
            this.$store.state.mainMenu.push(cat);
          }
        }
        */
      });

      if (favCat.items.length > 0) {
        this.$store.state.menu.unshift(favCat);

        //if (this.$store.state.mainMenu.length > 0) this.$store.state.mainMenu.unshift(favCat);
      }

      /*
      if (rdmCat.items.length > 0 && this.$store.state.pointEnabled) {
        this.$store.state.menu.unshift(rdmCat);
      }
      */
      //console.log("menu", this.$store.state.menu);
      //console.log("redeemMenu", this.$store.state.redeemMenu);
    },

    searchMenuItem() {
      let params = { mode: "search" };
      this.navName("MenuItem", params);
    },

    searchRedeemItem() {
      let params = { mode: "search" };
      this.navName("MenuItem", params);
    },

    getOrderItemSubtotal(oi) {
      return (oi.item != null && oi.item.scalable ? oi.price * oi.item.weight : oi.price) + oi.optionValue + oi.bAdj;
    },

    getOrderItemDiscountedSubtotal(oi) {
      let discSub = this.getOrderItemSubtotal(oi);
      if (oi.itemDiscountable) {
        if (oi.itemDiscountRate > 0) {
          if (oi.optionDiscountable) discSub = discSub * (1 - oi.itemDiscountRate / 100);
          else discSub = (discSub - oi.optionValue) * (1 - oi.itemDiscountRate / 100) + oi.optionValue;
        }
      }
      return discSub;
    },

    getOrderItemTotal(oi) {
      return oi.qty * this.getOrderItemSubtotal(oi);
    },

    getOrderItemDiscountTotal(oi) {
      let value = 0;
      if (oi.itemDiscountable) {
        if (oi.itemDiscountRate > 0) {
          let discountableTotal = this.getOrderItemTotal(oi);
          if (!oi.optionDiscountable) {
            discountableTotal -= oi.qty * oi.optionValue;
          }
          value = discountableTotal * (oi.itemDiscountRate / 100);
        } else value = oi.itemDiscountValue;
      } else value = 0;

      return value;
    },

    getOrderItemExtended(oi) {
      return this.getOrderItemTotal(oi) - this.getOrderItemDiscountTotal(oi);
    },

    itemToOrderItem(item) {
      let oi = {
        ID: 0,
        descr: "",
        descr1: "",
        descr2: "",
        barcode: "",
        groupID: "",
        remark: "",
        options: [],
        price: 0,
        qty: 1,
        optionValue: 0,
        extended: 0,
        gst: false,
        pst: false,
        liq: false,
        bItem: false,
        bundleItems: [],
        bundleChangeFees: 0,
        bAdj: 0,
        combos: [],
        combo: {},
        tag: "",
        cbRefID: 0,
        redeemItem: false,
        redeemPoints: 0,
        detail: "",
        detail1: "",
        detail2: "",
        itemDiscountable: true,
        billDiscountable: true,
        optionDiscountable: true,
        itemDiscountRate: 0,
        itemDiscountValue: 0,
        replaceDescrWithOption: false,
        o_price: 0,
        o_optionValue: 0,
        ord_descr: "",
        ord_descr1: "",
        ord_descr2: "",
        ord_did: 0,
        ord_time: Date.now(),
        item: null,
        promo: null,
      };

      oi.item = this.cloneObject(item);
      oi.promo = item.promo;
      oi.ID = item.ID;
      oi.descr = item.descr;
      oi.descr1 = item.descr1;
      oi.descr2 = item.descr2;
      oi.barcode = item.barcode;
      oi.detail = item.detail;
      oi.detail1 = item.detail1;
      oi.detail2 = item.detail2;
      oi.billDiscountable = item.discountable == null ? true : item.discountable;
      oi.itemDiscountable = item.itemDiscountable == null ? true : item.itemDiscountable;
      oi.optionDiscountable = item.optionDiscountable == null ? true : item.optionDiscountable;
      oi.itemDiscountRate = item.itemDiscountRate == null ? 0 : item.itemDiscountRate;
      oi.itemDiscountValue = item.itemDiscountValue == null ? 0 : item.itemDiscountValue;
      oi.price = item.price;
      oi.gst = item.gst;
      oi.pst = item.pst;
      oi.liq = item.liq;
      oi.bItem = item.bItem;
      oi.combos = item.combos;
      oi.tag = item.tag;
      oi.redeemItem = item.redeemItem !== undefined && item.redeemItem;
      oi.redeemPoints = item.redeemPoints;

      oi.options = [];
      if (oi.item.options != null)
        for (let cg of oi.item.options) {
          if (!("ordered" in cg)) {
            cg.ordered = Array();
          }
          let cg_items = [];
          cg.qty = 0;
          for (let cg_item of cg.items) {
            if (cg_item.descr != "") {
              cg_items.push(cg_item);
              cg_item.o_price = cg_item.price;
              if (oi.redeemItem && cg_item.redeemable) {
                cg_item.price = 0;
              }
              if (cg_item.chodef) {
                cg_item.qty = 1;
                cg.qty++;
                if (!cg.opt) {
                  cg_item.toggle = true;
                }
                let oo = {
                  cgID: cg.ID,
                  ID: cg_item.ID,
                  qty: 1,
                  optionPrice: cg_item.price,
                  price: cg_item.price,
                  time: Date.now(),
                };
                cg.ordered.push(oo);
              } else {
                cg_item.qty = 0;
                cg_item.toggle = false;
              }
            }
          }

          if (cg_items.length > 0) {
            cg.items = cg_items;
            oi.options.push(cg);
          }
        }

      this.updateOptionsValue(oi);
      oi.replaceDescrWithOption = oi.descr.substr(0, 1) == "*";
      oi.ord_did = this.$store.state.ordDidCount++;
      oi.ord_descr = this.getOrderText(oi, 0);
      oi.ord_descr1 = this.getOrderText(oi, 1);
      oi.ord_descr2 = this.getOrderText(oi, 2);
      oi.o_price = item.price;

      if (oi.redeemItem) {
        oi.price = 0;
        oi.tag = "";
        oi.combos = undefined;
      }

      if (oi.item.bItems != null && oi.item.bItems.length > 0 && this.$store.state.serverBuildNo >= 143) {
        console.log("itemToOrderItem bItems", oi.item.bItems);
        oi.bundleChangeFees = item.bundleChangeFees;
        oi.item.bItems.forEach(bi => {
          let n_bi = {
            bItem: true,

            applyDiff: bi.applyDiff,
            itemPrice: oi.promo == null ? bi.item.price : 0,
            catIDs: bi.defCatID != null ? [bi.defCatID] : bi.catIDs,
            catCodes: bi.catCodes,
            itemCodes: bi.itemCodes,
            itemDiscountRate: bi.itemDiscountRate,
            itemDiscountValue: bi.itemDiscountValue,
            qty: bi.qty != null ? bi.qty : 1,

            replaceWithNewItem:
              bi.item.descr.substr(0, 1) ==
              "?" /* ||
                  bi.item.descr1.substr(0, 1) == "?" ||
                  bi.item.descr2.substr(0, 1) == "?"*/,
            orderItem: {},
            accepted: false,
            bundleItemPrice: 0,
          };
          bi.item.itemDiscountRate = bi.itemDiscountRate;
          bi.item.itemDiscountValue = bi.itemDiscountValue;

          let n_boi = this.itemToOrderItem(bi.item);
          n_bi.orderItem = n_boi;
          n_bi.orderItem.qty = n_bi.qty;
          oi.bundleItems.push(n_bi);
        });
      }

      return oi;
    },

    getOrderText(oi, descrIndex) {
      let itemText = "";
      if (descrIndex == 1 && oi.descr1 != null && oi.descr1 != "") itemText = oi.descr1;
      else if (descrIndex == 2 && oi.descr2 != null && oi.descr2 != "") itemText = oi.descr2;
      else itemText = oi.descr;
      let optText = this.getOptionsText(oi, descrIndex);

      let result = "";
      if (oi.replaceDescrWithOption) {
        if (optText == "") {
          result = itemText;
          if (result.substr(0, 1) == "*" && result.length >= 2) {
            result = result.substr(1);
          }
        } else result = optText;
      } else if (itemText.substr(0, 1) == "?") {
        if (itemText.length >= 2) itemText = itemText.substr(1);
        else {
          let lang = this.$store.getters.languages.find(language => language.descrIndex == descrIndex);
          if (lang != null) {
            itemText = this.$t("pick_your_own", lang.locale);
          }
        }
        result = itemText + optText;
      } else {
        result = itemText + optText;
      }
      return result;
    },

    getOptionsText(oi, descrIndex) {
      let result = "";
      let lastHeaderName = "";
      for (let og of oi.options) {
        let prefix = " ";
        let delimiter = " ";
        let headerName = "";
        if (og.printHeaderName !== undefined && og.printHeaderName) {
          if (descrIndex == 1 && og.name1 != "") headerName = og.name1;
          else if (descrIndex == 2 && og.name2 != "") headerName = og.name2;
          else headerName = og.name;

          if (headerName != "") headerName = "\n" + headerName + " : ";

          lastHeaderName = headerName;
        }
        if (og.prefix !== undefined) prefix = og.prefix;
        if (og.delimiter !== undefined) delimiter = og.delimiter;

        if (headerName == "" && lastHeaderName != "") prefix = "\n";
        else if (prefix == "space" || prefix == "enter") prefix = " ";
        else if (prefix == "empty") prefix = "";

        if (delimiter == "space" || delimiter == "enter") delimiter = " ";
        else if (delimiter == "empty") delimiter = "";

        let optInGrp = "";
        for (let opt of og.items) {
          let optDescr = "";
          if (descrIndex == 1 && opt.descr1 != "") optDescr = opt.descr1;
          else if (descrIndex == 2 && opt.descr2 != "") optDescr = opt.descr2;
          else optDescr = opt.descr;

          if (opt.qty > 0)
            optInGrp += (optInGrp == "" ? "" : delimiter) + (opt.qty == 1 ? optDescr : opt.qty + "x" + optDescr);
        }
        if (optInGrp != "") {
          result += headerName + prefix + optInGrp;
        }
      }
      return result;
    },

    updateOptionsValue(oi) {
      let optValue = 0;

      let optDiscRate = oi.combo.optionDiscountable != null && oi.combo.optionDiscountable ? oi.combo.discountRate : 0;
      for (let og of oi.options) {
        if (og.ordered != null) {
          let counter = og.ordered.length;
          if (og.chgqty > 0) {
            if (og.chgway == 0) og.ordered.sort(this.sortOptionByTime);
            else if (og.chgway == 1) og.ordered.sort(this.sortOptionByPrice);
            else if (og.chgway == 2) og.ordered.sort(this.sortOptionByHighestPrice);

            counter = og.chgqty;
          }

          if (oi.combos == null || oi.cbRefID == 0 || oi.combo.optionOntop) {
            for (let opt of og.ordered) {
              let addOptPrice = true;
              if (og.chgqty > 0 && (oi.cbRefID == 0 || oi.combo.optionOntop)) {
                if (og.chgway == 0) addOptPrice = counter <= 0;
                else if (og.chgway == 1) addOptPrice = counter <= 0;
                else if (og.chgway == 2) addOptPrice = counter > 0;
              }

              if (addOptPrice) {
                //optValue += opt.optionPrice;
                opt.price = opt.optionPrice;
              } else {
                opt.price = 0;
              }

              optValue += opt.price;

              if (opt.optionPrice > 0) counter--;
            }
          }
        }
      }

      oi.o_optionValue = optValue;
      oi.optionValue = optValue * (1 - optDiscRate / 100.0);
    },

    sortOptionByTime(a, b) {
      if (a.time > b.time) return 1;
      else if (a.time < b.time) return -1;
      else return 0;
    },

    sortOptionByLatestTime(a, b) {
      if (a.time < b.time) return 1;
      else if (a.time > b.time) return -1;
      else return 0;
    },

    sortOptionByPrice(a, b) {
      if (a.price > b.price) return 1;
      else if (a.price < b.price) return -1;
      else return 0;
    },

    sortOptionByHighestPrice(a, b) {
      if (a.price < b.price) return 1;
      else if (a.price > b.price) return -1;
      else return 0;
    },

    linkCombo(orderItem) {
      if (orderItem == null) return false;
      if (orderItem.cbRefID > 0) return false;

      let linked = false;
      if (orderItem.tag != "") {
        let loopCount = orderItem.qty;
        for (let i = 0; i < loopCount; i++) {
          let combosFound = false;
          for (let oi of this.$store.state.order.orderItems) {
            if (oi.cbRefID == 0 && oi.combos !== undefined) {
              for (let cb of oi.combos) {
                if (cb.tag == orderItem.tag) {
                  if (oi.qty > 1) {
                    let cloneOi = this.cloneObject(oi);
                    cloneOi.qty = cloneOi.qty - 1;
                    cloneOi.ord_did = this.$store.state.ordDidCount++;
                    this.$store.state.order.orderItems.push(cloneOi);

                    oi.qty = 1;
                  }

                  let cloneOrderItem;
                  if (orderItem.qty == 1) cloneOrderItem = orderItem;
                  else {
                    cloneOrderItem = this.cloneObject(orderItem);
                    cloneOrderItem.qty = 1;
                    cloneOrderItem.ord_did = this.$store.state.ordDidCount++;

                    orderItem.qty--;

                    this.$store.state.order.orderItems.push(cloneOrderItem);
                  }

                  oi.combo = cb;

                  if (cb.price != null) {
                    oi.price = cb.price;
                    if (cb.optionOntop != null && !cb.optionOntop) {
                      oi.optionValue = 0;
                    }
                  } else if (cb.discountRate != null) {
                    oi.price = this.roundNumber(oi.o_price * (1 - cb.discountRate / 100), 2);
                    let optionDiscountRate = cb.optionDiscountable ? cb.discountRate : 0;
                    oi.optionValue = this.roundNumber(oi.o_optionValue * (1 - optionDiscountRate / 100), 2);
                  }
                  let cbRefID =
                    (this.$store.state.order.cbRefIDs.length == 0 ? 0 : Math.max(...this.$store.state.order.cbRefIDs)) +
                    1;

                  oi.cbRefID = cbRefID;
                  cloneOrderItem.cbRefID = cbRefID;

                  combosFound = true;
                  linked = true;

                  if (cbRefID > 0) {
                    if (this.$store.state.order.cbRefIDs.indexOf(cbRefID) < 0) {
                      this.$store.state.order.cbRefIDs.push(cbRefID);
                    }
                  }
                  break;
                }
              }
            }
            if (combosFound) break;
          }

          if (!combosFound) {
            break;
          }
        }
      } else if (Array.isArray(orderItem.combos) && orderItem.combos.length > 0) {
        let loopCount = orderItem.qty;
        for (let i = 0; i < loopCount; i++) {
          let tagFound = false;
          for (let cb of orderItem.combos) {
            for (let oi of this.$store.state.order.orderItems) {
              if (oi.cbRefID == 0 && cb.tag == oi.tag) {
                if (oi.qty > 1) {
                  let cloneOi = this.cloneObject(oi);
                  cloneOi.qty = cloneOi.qty - 1;
                  cloneOi.ord_did = this.$store.state.ordDidCount++;
                  this.$store.state.order.orderItems.push(cloneOi);

                  oi.qty = 1;
                }

                let cloneOrderItem;
                if (orderItem.qty == 1) cloneOrderItem = orderItem;
                else {
                  cloneOrderItem = this.cloneObject(orderItem);
                  cloneOrderItem.qty = 1;
                  cloneOrderItem.ord_did = this.$store.state.ordDidCount++;

                  orderItem.qty--;

                  this.$store.state.order.orderItems.push(cloneOrderItem);
                }

                cloneOrderItem.combo = cb;

                if (cb.price != null) {
                  cloneOrderItem.price = cb.price;
                  if (cb.optionOntop != null && !cb.optionOntop) cloneOrderItem.optionValue = 0;
                } else if (cb.discountRate != null) {
                  cloneOrderItem.price = this.roundNumber(cloneOrderItem.o_price * (1 - cb.discountRate / 100), 2);
                  if (cb.optionOntop) {
                    let optionDiscountRate = cb.optionDiscountable ? cb.discountRate : 0;
                    cloneOrderItem.optionValue = this.roundNumber(
                      cloneOrderItem.o_optionValue * (1 - optionDiscountRate / 100),
                      2
                    );
                  }
                }

                let cbRefID =
                  (this.$store.state.order.cbRefIDs.length == 0 ? 0 : Math.max(...this.$store.state.order.cbRefIDs)) +
                  1;

                oi.cbRefID = cbRefID;
                cloneOrderItem.cbRefID = cbRefID;

                tagFound = true;
                linked = true;

                if (cbRefID > 0) {
                  if (this.$store.state.order.cbRefIDs.indexOf(cbRefID) < 0) {
                    this.$store.state.order.cbRefIDs.push(cbRefID);
                  }
                }
                break;
              }
            }
            if (tagFound) break;
          }

          if (!tagFound) {
            break;
          }
        }
      }

      // if (linked && cbRefID > 0) {
      //   if (this.$store.state.order.cbRefIDs.indexOf(cbRefID) < 0) {
      //     this.$store.state.order.cbRefIDs.push(cbRefID);
      //   }
      // }

      return linked;
    },

    unlinkCombo(orderItem) {
      let cbRefID = orderItem.cbRefID;
      let linkedOrderItem = this.getLinkedOrderItem(orderItem);
      if (linkedOrderItem != null) {
        if (Array.isArray(linkedOrderItem.combos) && linkedOrderItem.combos.length > 0) {
          linkedOrderItem.price = linkedOrderItem.o_price;
          linkedOrderItem.optionValue = linkedOrderItem.o_optionValue;
        }
        linkedOrderItem.cbRefID = 0;
      }
      orderItem.cbRefID = 0;

      let indexOfIDs = this.$store.state.order.cbRefIDs.indexOf(cbRefID);
      if (indexOfIDs >= 0) {
        this.$store.state.order.cbRefIDs.splice(indexOfIDs, 1);
      }
    },

    getLinkedOrderItem(orderItem) {
      let linkedOrderItem = null;
      if (orderItem.cbRefID > 0) {
        for (let oi of this.$store.state.order.orderItems) {
          if (oi.ord_did != orderItem.ord_did && oi.cbRefID == orderItem.cbRefID) {
            linkedOrderItem = oi;
            break;
          }
        }
      }
      return linkedOrderItem;
    },

    getItemOrderedQty(itemID) {
      let qty = 0;
      let ele = this.$store.state.orderedCounter.find(ele => ele.ID == itemID);
      if (ele != null) qty = ele.qty;
      return qty;
    },

    calculateTotal() {
      // console.log("store info", this.$store.state.store.info);

      let gstRate = this.$store.state.store.info.gstRate / 100;
      let pstRate = this.$store.state.store.info.pstRate / 100;
      let liqRate = this.$store.state.store.info.liqRate / 100;
      let gstExt = 0;
      let pstExt = 0;
      let liqExt = 0;
      let dgstExt = 0;
      let dpstExt = 0;
      let dliqExt = 0;
      let gstTax = 0;
      let pstTax = 0;
      let liqTax = 0;
      let classify1Qty = 0;

      let deliveryGstRate = this.$store.state.store.info.deliveryGstRate / 100;
      let deliveryPstRate = this.$store.state.store.info.deliveryPstRate / 100;
      let serviceGstRate = this.$store.state.store.info.serviceGstRate / 100;
      let servicePstRate = this.$store.state.store.info.servicePstRate / 100;

      let billDiscountableTotal = 0;
      this.$store.state.order.qtyTotal = 0;
      this.$store.state.order.redeemedPointsTotal = 0;
      this.$store.state.order.subtotal = 0;
      this.$store.state.orderedCounter = [];
      this.$store.state.order.tax = 0;
      this.$store.state.order.qtyTotal = 0;
      this.$store.state.order.discountRate = 0;
      this.$store.state.order.discountValue = 0;
      this.$store.state.order.serviceRate = 0;
      this.$store.state.order.serviceValue = 0;

      // get classify 1 count
      for (let oi of this.$store.state.order.orderItems) {
        let classify1 = oi.item != null && oi.item.classify == 1;
        if (classify1) classify1Qty += oi.qty;

        oi.extended = this.getOrderItemExtended(oi);
      }
      for (let oi of this.$store.state.order.orderItems) {
        let ext = oi.extended;
        this.$store.state.order.subtotal += ext;

        let classify1 = this.$store.getters.storeAddress.province == "ON" && oi.item != null && oi.item.classify == 1;
        if (!classify1 || classify1Qty < 6) {
          if (oi.gst) {
            gstExt += ext;
            gstTax += ext * gstRate;

            dgstExt += oi.billDiscountable ? ext : 0;
          }
          if (oi.pst) {
            pstExt += ext;
            pstTax += ext * pstRate;

            dpstExt += oi.billDiscountable ? ext : 0;
          }
          if (oi.liq) {
            liqExt += ext;
            liqTax += ext * liqRate;

            dliqExt += oi.billDiscountable ? ext : 0;
          }
        }

        this.$store.state.order.qtyTotal += oi.qty;
        if (oi.redeemItem) {
          this.$store.state.order.redeemedPointsTotal += oi.redeemPoints * oi.qty;
        }

        if (oi.billDiscountable) {
          billDiscountableTotal += ext;
        }

        let ele = this.$store.state.orderedCounter.find(ele => ele.ID == oi.ID);
        if (ele == null) {
          ele = { ID: oi.ID, qty: oi.qty };
          this.$store.state.orderedCounter.push(ele);
        } else {
          ele.qty += oi.qty;
        }
      }

      // get discount value - begin
      let memberDiscountRate = 0;
      if (this.$store.state.member != null && this.$store.state.member.MemberMetadata !== undefined) {
        let memberMetadata = this.$store.state.member.MemberMetadata;
        if (memberMetadata.MemberExDiscountRate > 0) {
          memberDiscountRate = memberMetadata.MemberExDiscountRate;
        } else if (memberMetadata.MemberExVIP) {
          memberDiscountRate = this.$store.state.store.info.vipDiscountRate;
        }
      }

      let orderDiscValue = 0;
      let orderDiscByPercentage = true;
      let promoDiscMinAmount = 0;
      let promoSubOi = this.$store.state.order.orderItems.find(oi => oi.promo != null);
      let promoSubOiExt = 0;
      if (promoSubOi != null) {
        if (
          promoSubOi.promo.TargetType == "subtotal" &&
          promoSubOi.promo.DiscValue != null &&
          typeof promoSubOi.promo.DiscValue == "number"
        ) {
          orderDiscValue = promoSubOi.promo.DiscValue;
          orderDiscByPercentage = promoSubOi.promo.DiscByPercentage == null || promoSubOi.promo.DiscByPercentage;
        }

        if (promoSubOi.promo.MinAmount != null && typeof promoSubOi.promo.MinAmount == "number")
          promoDiscMinAmount = promoSubOi.promo.MinAmount;

        promoSubOiExt = promoSubOi.extended;
      }

      if (orderDiscValue == 0 || this.$store.state.order.subtotal - promoSubOiExt < promoDiscMinAmount) {
        orderDiscByPercentage = true;
        orderDiscValue = Math.max(this.$store.state.order.defaultDiscountRate, memberDiscountRate);
      }

      if (orderDiscValue > 0) {
        if (orderDiscByPercentage) {
          this.$store.state.order.discountRate = orderDiscValue;
          this.$store.state.order.discountValue = billDiscountableTotal * (orderDiscValue / 100);
        } else {
          this.$store.state.order.discountValue = orderDiscValue;
        }
      }
      // get discount value - end

      if (this.$store.state.store.info.taxOnDiscountedSubtotal) {
        let gDisc = 0;
        let pDisc = 0;
        let lDisc = 0;
        if (this.$store.state.order.discountRate > 0) {
          gDisc = dgstExt * (this.$store.state.order.discountRate / 100);
          pDisc = dpstExt * (this.$store.state.order.discountRate / 100);
          lDisc = dliqExt * (this.$store.state.order.discountRate / 100);
        } else if (this.$store.state.order.discountValue > 0) {
          gDisc = dgstExt >= this.$store.state.order.discountValue ? this.$store.state.order.discountValue : 0;
          pDisc = dpstExt >= this.$store.state.order.discountValue ? this.$store.state.order.discountValue : 0;
          lDisc = dliqExt >= this.$store.state.order.discountValue ? this.$store.state.order.discountValue : 0;
        }

        gstTax = (gstExt - gDisc) * gstRate;
        pstTax = (pstExt - pDisc) * pstRate;
        liqTax = (liqExt - lDisc) * liqRate;
      }

      gstTax = this.roundNumber(gstTax, 2);
      pstTax = this.roundNumber(pstTax, 2);
      liqTax = this.roundNumber(liqTax, 2);

      gstTax = gstTax < 0 ? 0 : gstTax;
      pstTax = pstTax < 0 ? 0 : pstTax;
      liqTax = liqTax < 0 ? 0 : liqTax;

      this.$store.state.order.tax = gstTax + pstTax + liqTax;

      // calculate delivery charge
      console.log("order", this.$store.state.order);
      if (
        this.$store.state.order.minOrderForFreeDelivery > 0 &&
        this.$store.state.order.minOrderForFreeDelivery <=
          this.$store.state.order.subtotal - this.$store.state.order.discountValue
      ) {
        this.$store.state.order.deliveryValue = 0;
      } else {
        this.$store.state.order.deliveryValue = this.$store.state.order.deliveryValueByAddress;
      }

      // calculate service charge
      let subtotalForService = this.$store.state.order.subtotal;
      if (this.$store.state.store.info.taxOnDiscountedSubtotal)
        subtotalForService -= this.$store.state.order.discountValue;

      if (this.$store.state.order.defaultServicePercentage) {
        this.$store.state.order.serviceRate = this.$store.state.order.defaultServiceValue;
        this.$store.state.order.serviceValue = subtotalForService * (this.$store.state.order.serviceRate / 100);
      } else {
        this.$store.state.order.serviceValue = this.$store.state.order.defaultServiceValue;
      }

      // calculate tax
      if (this.$store.state.order.deliveryValue != 0) {
        let deliveryTax = this.$store.state.order.deliveryValue * (deliveryGstRate + deliveryPstRate);
        this.$store.state.order.tax += deliveryTax;
      }
      if (this.$store.state.order.serviceValue != 0) {
        let serviceTax = this.$store.state.order.serviceValue * (serviceGstRate + servicePstRate);
        this.$store.state.order.tax += serviceTax;
      }

      this.$store.state.order.subtotal = this.roundNumber(this.$store.state.order.subtotal, 2);
      this.$store.state.order.deliveryValue = this.roundNumber(this.$store.state.order.deliveryValue, 2);
      this.$store.state.order.tax = this.roundNumber(this.$store.state.order.tax, 2);
      this.$store.state.order.discountValue = this.roundNumber(this.$store.state.order.discountValue, 2);
      this.$store.state.order.serviceValue = this.roundNumber(this.$store.state.order.serviceValue, 2);

      this.$store.state.order.total =
        this.$store.state.order.subtotal +
        this.$store.state.order.deliveryValue +
        this.$store.state.order.serviceValue +
        this.$store.state.order.tax -
        this.$store.state.order.discountValue;
      this.$store.state.order.total = this.roundNumber(this.$store.state.order.total, 2);
    },

    addOrderItem(orderItem) {
      console.log("addOrderItem", orderItem);

      this.$store.state.order.orderItems.push(orderItem);
      this.linkCombo(orderItem);
      this.countQtyTotal();
      this.calculateTotal();
      this.setOrderToStorage();

      console.log("orderItems", this.$store.state.order.orderItems);
    },

    removeOrderItem(orderItem) {
      let linkedOrderItem = this.getLinkedOrderItem(orderItem);
      this.unlinkCombo(orderItem);

      const index = this.$store.state.order.orderItems.indexOf(orderItem);
      this.$store.state.order.orderItems.splice(index, 1);

      this.linkCombo(linkedOrderItem);

      if (this.$store.state.order.orderItems.length == 0) {
        this.$store.state.order.address = null;
        this.$store.state.order.deliveryValueByAddress = 0;
        this.$store.state.order.deliveryWithhold = 0;
      }

      this.calculateTotal();
      this.setOrderToStorage();
    },

    clearOrder() {
      try {
        let orderType = this.$store.state.OT_TAKEOUT;
        if (this.$store.state.order != null) {
          if (this.$store.state.order.orderType != null) orderType = this.$store.state.order.orderType;
        }
        this.$store.state.order.orderUUID = uuidv4();
        this.$store.state.order.orderType = orderType;
        this.$store.state.order.orderItems = [];
        this.$store.state.order.subtotal = 0;
        this.$store.state.order.deliveryValue = 0;
        this.$store.state.order.deliveryValueByAddress = 0;
        this.$store.state.order.deliveryWithhold = 0;
        this.$store.state.order.defaultDiscountRate = 0;
        this.$store.state.order.discountRate = 0;
        this.$store.state.order.discountValue = 0;
        this.$store.state.order.serviceRate = 0;
        this.$store.state.order.serviceValue = 0;
        this.$store.state.order.tax = 0;
        this.$store.state.order.tips = 0;
        this.$store.state.order.total = 0;
        this.$store.state.order.qtyTotal = 0;
        this.$store.state.order.redeemedPointsTotal = 0;
        this.$store.state.order.payAmount = 0;
        this.$store.state.order.payData = null;
        this.$store.state.order.address = null;
        this.$store.state.order.dineInAway = false;
        this.$store.state.order.checkoutTime = null;
        this.$store.state.order.pickupTime = null;
        this.$store.state.order.deliveryTime = null;
        this.$store.state.order.deliveryTimeTo = null;
        this.$store.state.order.memo = "";
        this.$store.state.order.minOrder = 0;
        this.$store.state.order.minOrderForFreeDelivery = 0;
        this.$store.state.order.utensils = true;
        this.$store.state.order.alwaysSendPickupTime = false;
        this.$store.state.order.priceLevel = 0;
        this.$store.state.order.distance = 0;
        this.$store.state.order.lastUpdated = Date.now();
        this.$store.state.order.cbRefIDs = [];

        this.$store.state.order.faceDrive = undefined;
        this.$store.state.order.doorDash = undefined;

        this.setOrderType(orderType);

        this.$store.state.orderedCounter = [];
      } catch (error) {
        console.log(error);
      }
    },

    generateReferenceID() {
      let str = "00000" + Math.floor(Math.random() * 100000).toString();
      let referenceID = str.substr(str.length - 5);

      return referenceID;
    },

    updateOrderLogin(loginAsMember) {
      if (loginAsMember) {
        if (this.$store.state.member != null) {
          this.$store.state.order.memberCode = this.$store.state.member.MemberCode;

          this.$store.state.order.phoneID = this.$store.state.member.PhoneId;
          this.$store.state.order.login = {
            name: this.$store.getters.memberFullName,
            firstName: this.$store.state.member.MemberFirstName,
            lastName: this.$store.state.member.MemberLastName,
            email: this.$store.state.member.MemberEMail,
            phone1: this.$store.state.member.PhoneId.substring(2),
            phoneVerified: true,
            isMember: true,
          };
        }
      } else {
        this.$store.state.order.memberCode = "";
        this.$store.state.order.phoneID = "";
        this.$store.state.order.login = this.$store.state.guest;
      }
      this.setOrderToStorage();
    },

    orderToFeed(order) {
      try {
        if (order == null) order = this.$store.state.order;

        let orderMemo = order.memo;
        let billMemo = "";
        if (this.$store.state.memoAsBillMemo) {
          billMemo = orderMemo;
          orderMemo = "";
        }
        if (
          (order.orderType == this.$store.state.OT_TAKEOUT || order.orderType == this.$store.state.OT_DELIVERY) &&
          !this.$store.state.notAskUtensils
        ) {
          if (this.$store.state.utensils && !order.utensils) {
            billMemo += (billMemo == "" ? "" : ", ") + this.$t("no_utensils");
          } else if (!this.$store.state.utensils && order.utensils) {
            billMemo += (billMemo == "" ? "" : ", ") + this.$t("need_utensils");
          }
        }

        let checkoutTime = this.toSQLDateTimeString(order.checkoutTime);

        let pickupTimeIgnored = false;
        if (
          order.orderType == this.$store.state.OT_DELIVERY &&
          (this.$store.getters.faceDriveEnabled || this.$store.getters.doorDashEnabled)
        ) {
          //pickupTimeIgnored = false;
        } else
          pickupTimeIgnored = !(
            !this.$store.getters.checkoutPickupTimeIgnored &&
            (this.$store.state.alwaysSendPickupTime || !this.$store.state.order.orderNow)
          );

        let pickupTime = this.toSQLDateTimeString(order.pickupTime);
        let deliveryTime = this.toSQLDateTimeString(order.deliveryTime);

        let pickupAddress;
        if (this.$store.getters.doorDashEnabled || this.$store.getters.faceDriveEnabled) {
          pickupAddress = this.cloneObject(this.$store.getters.storeAddress);
          if (this.$store.getters.storeInfo != null) {
            pickupAddress.name = this.$store.getters.storeInfo.companyName;
          }
        }

        let deliveryAddress = this.cloneObject(order.address);

        if (this.$store.state.serverBuildNo <= 163) {
          if (
            pickupAddress !== undefined &&
            pickupAddress != null &&
            pickupAddress.unit != "" &&
            pickupAddress.street != ""
          ) {
            pickupAddress.street = "Unit " + pickupAddress.unit + " " + pickupAddress.street;
            pickupAddress.unit = "";
          }
          if (deliveryAddress != null && deliveryAddress.unit != "" && deliveryAddress.street != "") {
            deliveryAddress.street = "Unit " + deliveryAddress.unit + " " + deliveryAddress.street;
            deliveryAddress.unit = "";
          }
        }

        let feed = {
          orderUUID: order.orderUUID,
          orderType: order.orderType,
          tableGroupID: order.tableGroupID,
          tableID: order.tableID,
          tableName: order.tableName,
          phoneID: order.phoneID,
          memberCode: order.memberCode,
          guest: order.login,
          address: deliveryAddress,
          dineInAway: order.dineInAway,

          checkoutTimeTz: order.checkoutTime == null ? null : this.toDate(order.checkoutTime).toISOString(),
          checkoutTime: checkoutTime,

          pickupTimeTz:
            pickupTime == null || order.pickupTime == null ? null : this.toDate(order.pickupTime).toISOString(),
          pickupTime: pickupTime,
          pickupAddress: pickupAddress,
          pickupTimeIgnored: pickupTimeIgnored,

          deliveryTimeTz: order.deliveryTime == null ? null : this.toDate(order.deliveryTime).toISOString(),
          deliveryTime: deliveryTime,
          deliveryWithhold: order.deliveryWithhold,

          orderMemo: orderMemo,
          billMemo: billMemo,
          items: [],
          discountRate: order.discountRate,
          discountValue: order.discountValue,
          deliveryValue: order.deliveryValue,
          serviceRate: order.serviceRate,
          serviceValue: order.serviceValue,
          doorDashDriveID: order.doorDashDriveID,
          faceDriveEnabled: order.faceDriveEnabled,
          subtotal: order.subtotal,
          tax: order.tax,
          tips: order.tips,
          total: order.total,
          payAmount: order.payAmount,
          paid: [
            {
              amount: order.payAmount,
              currency: order.currency,
              data: order.payData,
            },
          ],
          //referenceID: referenceID,
          doorDash: order.doorDash,
          faceDrive: order.faceDrive,
          app: this.$store.getters.appInfo,
        };

        for (let oi of order.orderItems) {
          if (oi.cbRefID == 0 || oi.combos == null || oi.combos.length == 0) {
            let n_price = oi.price;
            if (oi.redeemItem) {
              n_price = oi.o_price;
            }

            let n_optionValue = oi.optionValue;
            let n_idiscValue = 0;
            let n_discountValue = 0;
            let n_redeemedPoints = 0;

            let n_options = [];
            if (oi.redeemItem) {
              n_redeemedPoints = oi.redeemPoints;
              n_idiscValue = oi.o_price;
              n_optionValue = 0;
              for (let og of oi.options) {
                for (let opt of og.ordered) {
                  if (oi.redeemItem) {
                    n_optionValue += opt.price;
                    if (opt.redeemable) {
                      n_idiscValue += opt.price;
                    }
                  }

                  let n_opt = { ID: opt.ID, price: opt.price };
                  n_options.push(n_opt);
                }
              }
              n_discountValue = n_idiscValue * oi.qty;
            } else {
              for (let og of oi.options) {
                for (let opt of og.ordered) {
                  let n_opt = { ID: opt.ID, price: opt.price };
                  n_options.push(n_opt);
                }
              }
            }

            let n_oi = {
              ID: oi.ID,
              ord_descr: oi.ord_descr,
              ord_descr1: oi.ord_descr1,
              ord_descr2: oi.ord_descr2,
              qty: oi.qty,
              price: n_price,
              optionValue: n_optionValue,
              discountRate: !oi.redeemItem && oi.itemDiscountable ? oi.itemDiscountRate : 0,
              discountValue: n_discountValue,
              redeemedPoints: n_redeemedPoints,
              remark: oi.remark,
              cbRefID: oi.cbRefID,
              options: n_options,
              comboItem: null,
              bundleItems: [],
              bAdj: oi.bAdj,
              promoData: null,
              tag: oi.tag,
              scalable: oi.item.scalable ? oi.item.scalable : null,
              weight: oi.item.scalable ? oi.item.weight : null,
              weightUnit: oi.item.scalable ? oi.item.weightUnit : null,
            };
            if (oi.promo != null) {
              n_oi.promoData = {
                code: oi.promo.PromoteCode,
                title: oi.promo.Title,
                headline: oi.promo.Headline,
                remark: oi.promo.Remark,
                discValue: oi.promo.DiscValue,
                discByPercentage: oi.promo.DiscByPercentage,
                targetType: oi.promo.TargetType,
              };
              n_oi.descr = oi.promo.Title;
              n_oi.billDiscountable = oi.billDiscountable;
            }

            if (this.$store.state.serverBuildNo >= 143 && oi.bundleItems.length > 0) {
              for (let bi of oi.bundleItems) {
                let boi = bi.orderItem;
                let n_boi = {
                  ID: boi.ID,
                  ord_descr: boi.ord_descr,
                  ord_descr1: boi.ord_descr1,
                  ord_descr2: boi.ord_descr2,
                  qty: boi.qty,
                  price: boi.price,
                  optionValue: boi.optionValue,
                  discountValue: boi.itemDiscountValue,
                  discountRate: boi.itemDiscountRate,
                  remark: boi.remark,
                  options: [],
                };
                for (let og of boi.options) {
                  for (let opt of og.ordered) {
                    let n_opt = { ID: opt.ID, price: opt.price };
                    n_boi.options.push(n_opt);
                  }
                }
                n_oi.bundleItems.push(n_boi);
              }
            }

            feed.items.push(n_oi);
          }
        }

        for (let oi of order.orderItems) {
          if (!(oi.cbRefID == 0 || oi.combos === undefined || oi.combos.length == 0)) {
            let n_oi = {
              ID: oi.ID,
              ord_descr: oi.ord_descr,
              ord_descr1: oi.ord_descr1,
              ord_descr2: oi.ord_descr2,
              ord_subtotal: oi.qty * (oi.price + oi.optionValue),
              qty: oi.qty,
              price: oi.o_price,
              optionValue: oi.o_optionValue,
              remark: oi.remark,
              cbRefID: oi.cbRefID,
              options: [],
            };

            for (let og of oi.options) {
              for (let opt of og.ordered) {
                let n_opt = { ID: opt.ID, price: opt.price };
                n_oi.options.push(n_opt);
              }
            }

            for (let moi of feed.items) {
              if (moi.cbRefID == oi.cbRefID) {
                moi.comboItem = n_oi;
              }
            }
          }
        }

        if (this.$devEnv) console.log("order", order);
        if (this.$devEnv) console.log("feed", feed);

        return feed;
      } catch (error) {
        console.log(error);

        return null;
      }
    },

    async sendOrderToServer() {
      let sendResult = {
        result: "failed",
        referenceID: "",
        message: "",
        messageCode: "",
      };

      // debug - begin
      //sendResult.messageCode = "error_send_incorrect_order";
      // debug - end

      let canSendOrder = true;
      // redeem points
      if (this.$store.state.member != null && this.$store.state.pointEnabled) {
        if (this.$store.state.order.redeemedPointsTotal > 0) {
          let res = await this.rest_redeemMemberPoints(
            this.$store.state.member.MemberCode,
            this.$store.state.order.redeemedPointsTotal
          );
          if (res.result != "ok" && this.$store.state.order.payAmount == 0) {
            if (res.result == "non-sufficient points") {
              sendResult.messageCode = "error_non_sufficient_points";
            } else {
              sendResult.messageCode = "error_point_redeem";
            }

            canSendOrder = false;
          }
        }
      }

      // redeem promo
      if (canSendOrder) {
        let promoOi = this.$store.state.order.orderItems.find(oi => oi.promo != null);
        if (promoOi != null) {
          let res = await this.rest_redeemMemberPromo(this.$store.state.member.MemberCode, promoOi.promo);
          if (res.result != "ok" && this.$store.state.order.payAmount == 0) {
            let promoTitle = promoOi.promo.title;
            if (this.$store.state.descrIndex == 1) promoTitle = promoOi.promo.title1;
            else if (this.$store.state.descrIndex == 2) promoTitle = promoOi.promo.title2;
            sendResult.message = this.$t("error_promo_redeemed", {
              promo: promoTitle,
            });
            canSendOrder = false;
          }
        }
      }

      if (canSendOrder) {
        let feed = this.orderToFeed();
        if (feed == null) {
          sendResult.messageCode = "error_send_incorrect_order";
        } else if (feed.items.length > 0) {
          let orderType = this.$store.state.order.orderType;
          let res = await this.rest_sendOrder(feed);
          if (res.result == "ok") {
            if (res.doorDash != null) this.$set(this.$store.state.order, "doorDash", res.doorDash);
            if (res.faceDrive != null) this.$set(this.$store.state.order, "faceDrive", res.faceDrive);

            sendResult.result = res.result;
            sendResult.referenceID = feed.referenceID;

            let message = this.$t("order_reference_no") + "</h3><h1>" + res.referenceID + "</h1>";
            let timeZoneAbbrev = "";
            if (!this.$store.getters.storeTimeZoneMatched && this.$store.getters.storeTimeZoneAbbrev != "")
              timeZoneAbbrev = " (" + this.$store.getters.storeTimeZoneAbbrev + ")";
            if (orderType == this.$store.state.OT_TAKEOUT) {
              let pickupTime = this.toLocaleString(this.$store.state.order.pickupTime);
              let pickupAt = this.$store.getters.checkoutPickupTimeIgnored
                ? ""
                : "<br>" + this.$t("checkout.pickup_at") + "<br>" + pickupTime + timeZoneAbbrev + "<br>";
              message +=
                pickupAt +
                "<br>" +
                this.$t("pickup_address") +
                "<br>" +
                this.$store.getters.storeName +
                "<br>" +
                this.storeAddressString;
            } else if (orderType == this.$store.state.OT_DELIVERY) {
              let deliveryTime = this.toLocaleString(this.$store.state.order.deliveryTime);
              if (this.$store.state.order.deliveryTimeTo != null)
                deliveryTime += " - " + this.toLocaleTimeString(this.$store.state.order.deliveryTimeTo);
              let deliveryAt = this.$store.getters.checkoutPickupTimeIgnored
                ? ""
                : "<br>" + this.$t("checkout.delivery_at") + "<br>" + deliveryTime + timeZoneAbbrev + "<br>";
              message += deliveryAt + "<br>" + this.$t("delivery_address") + "<br>" + this.deliveryAddressString;
            }
            message += "<br><br>" + this.$t("checkout.review_order");
            this.$root.messageDialog(this.$t("order_successful"), "", "<h3>" + message);

            try {
              let memberCode = null;
              if (this.$store.state.member != null) memberCode = this.$store.state.member.MemberCode;
              this.updateMemberPromos(memberCode);
              this.addOrderHistory(res.referenceID);
              this.clearOrder();
              this.setOrderToStorage();
            } catch (error) {
              console.log(error);
            }
          } else {
            sendResult.message = res.message;
          }
        } else {
          sendResult.messageCode = "error_send_empty_order";
        }
      }

      if (sendResult.result != "ok") {
        let errorMessage = this.$t("error_send_order_11");
        if (sendResult.messageCode != "") errorMessage = this.$t(sendResult.messageCode);
        if (sendResult.message != "") errorMessage = sendResult.message;

        this.$root.messageDialog(this.$t("error_alert_title"), "", errorMessage);
      }

      return sendResult;
    },

    convertStorageFromIonic() {
      let lastLaunchTime = this.getLaunchTime();
      if (lastLaunchTime == null) {
        this.readIonicIndexedDb()
          .then(oldRecords => {
            //console.log(oldRecords);
            if (Array.isArray(oldRecords)) {
              oldRecords.forEach(record => {
                if (record.key.startsWith("LOC_")) {
                  this.setLastLogin(record.value);
                } else if (record.key.startsWith("ORD_")) {
                  this.setOrderToStorage(record.value);
                } else if (record.key.startsWith("OHX_")) {
                  this.setOrderHistory(record.value);
                } else if (record.key.startsWith("ADR_")) {
                  this.saveAddressList(record.value);
                } else if (record.key == "VERIFIED_PHONE_NUMBERS") {
                  let verifiedPhones = this.getVerifiedPhoneNumbers();
                  if (verifiedPhones == null) {
                    this.setVerifiedPhoneNumbers(record.value);
                  }
                }
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },

    /*     
      getDeliveryCharge(distance) {
          let charge = 0;
          let ruleMax;
          if (
            "orderType" in this.$store.state.store &&
            "delivery" in this.$store.state.store.orderType &&
            "chargeRules" in this.$store.state.store.orderType.delivery &&
            Array.isArray(this.$store.state.store.orderType.delivery.chargeRules)
          ) {
            let chargeRules = this.$store.state.store.orderType.delivery.chargeRules;
            chargeRules.forEach(rule => {
              if (rule.from < distance && rule.to >= distance) charge = rule.charge;
              if (ruleMax == null || rule.to > ruleMax.to) ruleMax = rule;
            });
    
            if (ruleMax != null && distance > ruleMax.to) charge = ruleMax.charge;
          }
          return charge;
        }, 
    */

    /*     
      getMaxDeliveryDistance() {
          let maxDistance = 0;
          if (
            "orderType" in this.$store.state.store &&
            "delivery" in this.$store.state.store.orderType &&
            "chargeRules" in this.$store.state.store.orderType.delivery &&
            Array.isArray(this.$store.state.store.orderType.delivery.chargeRules)
          ) {
            let chargeRules = this.$store.state.store.orderType.delivery.chargeRules;
            if (chargeRules.length > 0) {
              chargeRules.forEach(rule => {
                if (rule.to > maxDistance) maxDistance = rule.to;
              });
    
              if (this.$store.state.store.orderType.delivery.distance < maxDistance)
                maxDistance = this.$store.state.store.orderType.delivery.distance;
            } else maxDistance = this.$store.state.store.orderType.delivery.distance;
          }
    
          return maxDistance;
        }, 
    */
  },
};
